/* tslint:disable */
/* eslint-disable */
/**
 * Yubico Hidden Delivery Service API
 * This is the Yubico Delivery Service API containing public, but unexposed APIs.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AmountsPerCustomization
 */
export interface AmountsPerCustomization {
    /**
     * The customization ID. Null indicates a standard configuration (i.e. no customization). There might be more than one customization to choose from for the same product ID. 
     * @type {string}
     * @memberof AmountsPerCustomization
     */
    'customization_id': string | null;
    /**
     * Total number of keys purchased with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_total': number;
    /**
     * Number of keys remaining with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_remaining': number;
    /**
     * Number of keys possible to ship out right now with this customization ID
     * @type {number}
     * @memberof AmountsPerCustomization
     */
    'amount_shippable': number;
}
/**
 * 
 * @export
 * @interface BannerMessage
 */
export interface BannerMessage {
    /**
     * 
     * @type {BannerType}
     * @memberof BannerMessage
     */
    'type': BannerType;
    /**
     * 
     * @type {string}
     * @memberof BannerMessage
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BannerMessage
     */
    'message': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum BannerType {
    Info = 'info',
    Warning = 'warning',
    Urgent = 'urgent',
    Success = 'success'
}


/**
 * 
 * @export
 * @interface BulkCreateFailureReport
 */
export interface BulkCreateFailureReport {
    /**
     * 
     * @type {string}
     * @memberof BulkCreateFailureReport
     */
    'summary': string;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateFailureReport
     */
    'csv_lines_parsable': number;
    /**
     * 
     * @type {Array<FailedRow>}
     * @memberof BulkCreateFailureReport
     */
    'failed_rows': Array<FailedRow> | null;
}
/**
 * The carrier used to deliver a shipment
 * @export
 * @enum {string}
 */

export enum CarrierIdentifierEnum {
    BlueDart = 'bluedart',
    DPD = 'dpd',
    FedEx = 'fedex',
    FedExSameDay = 'fedex same day',
    Others = 'others',
    TecEx = 'tecex',
    IndiaPost = 'india-post',
    PitneyBowes = 'pitney bowes',
    RoyalMail = 'royal mail',
    Transnet = 'transnet',
    UPS = 'ups',
    USPS = 'usps',
    Unknown = 'coming soon'
}


/**
 * 
 * @export
 * @interface ChannelPartnerProductInventory
 */
export interface ChannelPartnerProductInventory {
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerProductInventory
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ChannelPartnerProductInventory
     */
    'product_name': string;
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerProductInventory
     */
    'remaining_quantity': number;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof ChannelPartnerProductInventory
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChannelPartnerProductInventory
     */
    'customizations'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ChannelPartnerProductInventory
     */
    'amount_total'?: number;
    /**
     * 
     * @type {Array<AmountsPerCustomization>}
     * @memberof ChannelPartnerProductInventory
     */
    'amounts_per_customization': Array<AmountsPerCustomization>;
}


/**
 * 
 * @export
 * @interface ChannelPartnerProductInventoryResponse
 */
export interface ChannelPartnerProductInventoryResponse {
    /**
     * 
     * @type {string}
     * @memberof ChannelPartnerProductInventoryResponse
     * @deprecated
     */
    'organization_id': string;
    /**
     * channelpartner_id is the key
     * @type {{ [key: string]: Array<ChannelPartnerProductInventory>; }}
     * @memberof ChannelPartnerProductInventoryResponse
     */
    'channelpartner_product_inventory': { [key: string]: Array<ChannelPartnerProductInventory>; };
}
/**
 * 
 * @export
 * @interface CreateBulkShipmentRequest
 */
export interface CreateBulkShipmentRequest {
    /**
     * 
     * @type {File}
     * @memberof CreateBulkShipmentRequest
     */
    'addresses_csv'?: File;
    /**
     * 
     * @type {ShipmentRequest}
     * @memberof CreateBulkShipmentRequest
     */
    'shipment_request'?: ShipmentRequest;
}
/**
 * 
 * @export
 * @interface CreateGrantsRequest
 */
export interface CreateGrantsRequest {
    /**
     * Required if no recipients list is given
     * @type {File}
     * @memberof CreateGrantsRequest
     */
    'recipients_csv'?: File;
    /**
     * 
     * @type {GrantsRequest}
     * @memberof CreateGrantsRequest
     */
    'grants_request': GrantsRequest;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponseSummary
 */
export interface CustomerPurchaseOrderResponseSummary {
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_city'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_country_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'closing_country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'vat_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'allow_automated_shipments': boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'key_contact_phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'order_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'organization_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'organizations_shippingaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'organizations_taxaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'organizations_vataccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'purchaseorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'yubicoorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'yubicoinvoice_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'purchaseorder_state_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'purchaseorder_state_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'shipping_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'shipping_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'tax_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'tax_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'total_keys_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'total_keys_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'vat_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'vat_credit_remaining'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'order_closing_date'?: string;
    /**
     * 
     * @type {PartnerPurchaseOrderResponseSummaryAllOfDistributor}
     * @memberof CustomerPurchaseOrderResponseSummary
     */
    'reseller': PartnerPurchaseOrderResponseSummaryAllOfDistributor | null;
}
/**
 * 
 * @export
 * @interface CustomerPurchaseOrderResponseSummaryAllOf
 */
export interface CustomerPurchaseOrderResponseSummaryAllOf {
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchaseOrderResponseSummaryAllOf
     */
    'order_closing_date'?: string;
    /**
     * 
     * @type {PartnerPurchaseOrderResponseSummaryAllOfDistributor}
     * @memberof CustomerPurchaseOrderResponseSummaryAllOf
     */
    'reseller': PartnerPurchaseOrderResponseSummaryAllOfDistributor | null;
}
/**
 * 
 * @export
 * @interface CustomizationHistoryResponseInner
 */
export interface CustomizationHistoryResponseInner {
    /**
     * 
     * @type {string}
     * @memberof CustomizationHistoryResponseInner
     */
    'customization_id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomizationHistoryResponseInner
     */
    'customization_name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomizationHistoryResponseInner
     */
    'date': string;
    /**
     * Email address of user who made last change will displayed if the user is in the same organization as the caller. For enterprise console users, a generic message will be displayed if the user is from another organization. 
     * @type {string}
     * @memberof CustomizationHistoryResponseInner
     */
    'user_email': string;
}
/**
 * 
 * @export
 * @interface DashboardResponse
 */
export interface DashboardResponse {
    /**
     * Ordered by tier, higher tiers first. Within the same tier, ordered by subscription type (primary 1.0 first, then backup 1.0, primary 2.0, backup 2.0). 
     * @type {Array<SubscriptionSummary>}
     * @memberof DashboardResponse
     */
    'subscriptions': Array<SubscriptionSummary>;
    /**
     * Ordered by product ID, lowest first 
     * @type {Array<ProductSummary>}
     * @memberof DashboardResponse
     */
    'perpetuals': Array<ProductSummary>;
}
/**
 * 
 * @export
 * @interface DistributorCustomerViewResponse
 */
export interface DistributorCustomerViewResponse {
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof DistributorCustomerViewResponse
     */
    'customer': OrganizationIdAndName;
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof DistributorCustomerViewResponse
     */
    'reseller': OrganizationIdAndName;
    /**
     * 
     * @type {DashboardResponse}
     * @memberof DistributorCustomerViewResponse
     */
    'inventory_summary': DashboardResponse;
}
/**
 * 
 * @export
 * @interface DistributorViewResponse
 */
export interface DistributorViewResponse {
    /**
     * 
     * @type {Array<DistributorViewResponseItem>}
     * @memberof DistributorViewResponse
     */
    'distributor_view_items': Array<DistributorViewResponseItem>;
}
/**
 * 
 * @export
 * @interface DistributorViewResponseItem
 */
export interface DistributorViewResponseItem {
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof DistributorViewResponseItem
     */
    'reseller': OrganizationIdAndName;
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof DistributorViewResponseItem
     */
    'customer': OrganizationIdAndName;
    /**
     * 
     * @type {number}
     * @memberof DistributorViewResponseItem
     */
    'purchaseorder_count': number;
}
/**
 * 
 * @export
 * @interface DistributorViewResultSet
 */
export interface DistributorViewResultSet {
    /**
     * 
     * @type {number}
     * @memberof DistributorViewResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof DistributorViewResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<DistributorViewResponseItem>}
     * @memberof DistributorViewResultSet
     */
    'distributor_view_items': Array<DistributorViewResponseItem>;
}
/**
 * 
 * @export
 * @interface EmailTemplateRequest
 */
export interface EmailTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateRequest
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateRequest
     */
    'body'?: string;
}
/**
 * 
 * @export
 * @interface EmailTemplateResponse
 */
export interface EmailTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateResponse
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateResponse
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateResponse
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateResponse
     */
    'title': string;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ErrorResult
 */
export interface ErrorResult {
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ErrorResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ErrorResult
     */
    'errors'?: Array<StandardErrorDetail>;
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResult
     * @deprecated
     */
    'errorCauses'?: Array<object>;
}
/**
 * 
 * @export
 * @interface ErrorResultAllOf
 */
export interface ErrorResultAllOf {
    /**
     * 
     * @type {string}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'errorCauses'?: Array<object>;
}
/**
 * 
 * @export
 * @interface FailedRow
 */
export interface FailedRow {
    /**
     * 
     * @type {number}
     * @memberof FailedRow
     */
    'row_number': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FailedRow
     */
    'errors': Array<string>;
}
/**
 * 
 * @export
 * @interface FeatureToggleCollectionResponse
 */
export interface FeatureToggleCollectionResponse {
    /**
     * 
     * @type {Array<FeatureToggleResponse>}
     * @memberof FeatureToggleCollectionResponse
     */
    'toggles': Array<FeatureToggleResponse>;
}
/**
 * 
 * @export
 * @interface FeatureToggleResponse
 */
export interface FeatureToggleResponse {
    /**
     * 
     * @type {string}
     * @memberof FeatureToggleResponse
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureToggleResponse
     */
    'enabled': boolean;
}
/**
 * @type GetDistributorViewSearchParameter
 * @export
 */
export type GetDistributorViewSearchParameter = Array<string> | string;

/**
 * 
 * @export
 * @interface GrantClaimProductRequest
 */
export interface GrantClaimProductRequest {
    /**
     * 
     * @type {string}
     * @memberof GrantClaimProductRequest
     */
    'grant_product_id': string;
    /**
     * 
     * @type {Array<GrantProductRedeem>}
     * @memberof GrantClaimProductRequest
     */
    'product_redeems': Array<GrantProductRedeem>;
}
/**
 * 
 * @export
 * @interface GrantClaimRequest
 */
export interface GrantClaimRequest {
    /**
     * 
     * @type {GrantClaimRequestRecipient}
     * @memberof GrantClaimRequest
     */
    'recipient': GrantClaimRequestRecipient;
    /**
     * 
     * @type {GrantClaimRequestMailingAddress}
     * @memberof GrantClaimRequest
     */
    'mailing_address': GrantClaimRequestMailingAddress;
    /**
     * 
     * @type {Array<GrantClaimProductRequest>}
     * @memberof GrantClaimRequest
     */
    'grant_products'?: Array<GrantClaimProductRequest>;
}
/**
 * 
 * @export
 * @interface GrantClaimRequestMailingAddress
 */
export interface GrantClaimRequestMailingAddress {
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestMailingAddress
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestMailingAddress
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestMailingAddress
     */
    'city'?: string;
    /**
     * Required if `country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof GrantClaimRequestMailingAddress
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestMailingAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestMailingAddress
     */
    'country_code_2'?: string;
}
/**
 * 
 * @export
 * @interface GrantClaimRequestRecipient
 */
export interface GrantClaimRequestRecipient {
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestRecipient
     */
    'recipient_company'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestRecipient
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestRecipient
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimRequestRecipient
     */
    'recipient_telephone'?: string;
}
/**
 * 
 * @export
 * @interface GrantClaimResponse
 */
export interface GrantClaimResponse {
    /**
     * 
     * @type {string}
     * @memberof GrantClaimResponse
     */
    'grant_id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimResponse
     */
    'recipient': string;
    /**
     * 
     * @type {string}
     * @memberof GrantClaimResponse
     */
    'expiration_date': string;
    /**
     * 
     * @type {Array<GrantProductResponse>}
     * @memberof GrantClaimResponse
     */
    'grant_products': Array<GrantProductResponse>;
    /**
     * 
     * @type {GrantShipmentResponse}
     * @memberof GrantClaimResponse
     */
    'shipment': GrantShipmentResponse | null;
}
/**
 * 
 * @export
 * @interface GrantCountry
 */
export interface GrantCountry {
    /**
     * 
     * @type {number}
     * @memberof GrantCountry
     */
    'country_id': number;
    /**
     * 
     * @type {string}
     * @memberof GrantCountry
     */
    'country_name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantCountry
     */
    'country_code_2': string;
}
/**
 * 
 * @export
 * @interface GrantDetailResponse
 */
export interface GrantDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'grant_id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'recipient': string;
    /**
     * 
     * @type {GrantStatusEnum}
     * @memberof GrantDetailResponse
     */
    'status': GrantStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'expiration_date': string;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'shipment_id': string | null;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof GrantDetailResponse
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantDetailResponse
     */
    'created_by': string;
    /**
     * 
     * @type {Array<GrantProduct>}
     * @memberof GrantDetailResponse
     */
    'grant_products': Array<GrantProduct>;
}


/**
 * 
 * @export
 * @interface GrantDetailResponseAllOf
 */
export interface GrantDetailResponseAllOf {
    /**
     * 
     * @type {Array<GrantProduct>}
     * @memberof GrantDetailResponseAllOf
     */
    'grant_products': Array<GrantProduct>;
}
/**
 * 
 * @export
 * @interface GrantMailingAddress
 */
export interface GrantMailingAddress {
    /**
     * 
     * @type {string}
     * @memberof GrantMailingAddress
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantMailingAddress
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantMailingAddress
     */
    'city'?: string;
    /**
     * Required if `country_code_2` is either \"US\" or \"CA\"
     * @type {string}
     * @memberof GrantMailingAddress
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantMailingAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantMailingAddress
     */
    'country_code_2'?: string;
}
/**
 * 
 * @export
 * @interface GrantProduct
 */
export interface GrantProduct {
    /**
     * 
     * @type {number}
     * @memberof GrantProduct
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof GrantProduct
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantProduct
     */
    'customization_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GrantProduct
     */
    'customization_label': string | null;
    /**
     * 
     * @type {number}
     * @memberof GrantProduct
     */
    'quantity': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GrantProduct
     */
    'redeemable_products': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof GrantProduct
     */
    'is_eligible': boolean;
}
/**
 * 
 * @export
 * @interface GrantProductInfo
 */
export interface GrantProductInfo {
    /**
     * 
     * @type {number}
     * @memberof GrantProductInfo
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof GrantProductInfo
     */
    'product_name': string;
    /**
     * 
     * @type {ProductTypeEnum}
     * @memberof GrantProductInfo
     */
    'product_type': ProductTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantProductInfo
     */
    'product_image': string;
}


/**
 * 
 * @export
 * @interface GrantProductRedeem
 */
export interface GrantProductRedeem {
    /**
     * 
     * @type {number}
     * @memberof GrantProductRedeem
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof GrantProductRedeem
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface GrantProductRequest
 */
export interface GrantProductRequest {
    /**
     * 
     * @type {number}
     * @memberof GrantProductRequest
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof GrantProductRequest
     */
    'customization_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GrantProductRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface GrantProductResponse
 */
export interface GrantProductResponse {
    /**
     * 
     * @type {string}
     * @memberof GrantProductResponse
     */
    'grant_product_id': string;
    /**
     * 
     * @type {number}
     * @memberof GrantProductResponse
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof GrantProductResponse
     */
    'quantity': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GrantProductResponse
     */
    'redeemable_products': Array<number>;
}
/**
 * 
 * @export
 * @interface GrantRecipient
 */
export interface GrantRecipient {
    /**
     * 
     * @type {string}
     * @memberof GrantRecipient
     */
    'recipient_company'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantRecipient
     */
    'recipient_firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantRecipient
     */
    'recipient_lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantRecipient
     */
    'recipient_telephone'?: string;
}
/**
 * 
 * @export
 * @interface GrantShipmentProduct
 */
export interface GrantShipmentProduct {
    /**
     * 
     * @type {number}
     * @memberof GrantShipmentProduct
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof GrantShipmentProduct
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof GrantShipmentProduct
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface GrantShipmentResponse
 */
export interface GrantShipmentResponse {
    /**
     * 
     * @type {string}
     * @memberof GrantShipmentResponse
     */
    'shipment_id': string;
    /**
     * 
     * @type {GrantRecipient}
     * @memberof GrantShipmentResponse
     */
    'recipient': GrantRecipient;
    /**
     * 
     * @type {GrantMailingAddress}
     * @memberof GrantShipmentResponse
     */
    'mailing_address': GrantMailingAddress;
    /**
     * 
     * @type {Tracking}
     * @memberof GrantShipmentResponse
     */
    'tracking': Tracking;
    /**
     * 
     * @type {ShipmentState}
     * @memberof GrantShipmentResponse
     */
    'shipment_state': ShipmentState;
    /**
     * 
     * @type {Array<GrantShipmentProduct>}
     * @memberof GrantShipmentResponse
     */
    'shipment_products': Array<GrantShipmentProduct>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum GrantStatusEnum {
    Invited = 'Invited',
    Claimed = 'Claimed',
    Expired = 'Expired',
    NeedsAttention = 'Needs Attention',
    Failed = 'Failed'
}


/**
 * 
 * @export
 * @interface GrantsRequest
 */
export interface GrantsRequest {
    /**
     * Must not be longer than 60 days from the current date.
     * @type {string}
     * @memberof GrantsRequest
     */
    'expiration_date': string;
    /**
     * Required if no recipients CSV is given
     * @type {Array<string>}
     * @memberof GrantsRequest
     */
    'recipients'?: Array<string>;
    /**
     * The ID of the entity through which a purchase order was submitted. Includes resellers and Yubico itself (channelpartner ID 1).
     * @type {number}
     * @memberof GrantsRequest
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof GrantsRequest
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {Array<GrantProductRequest>}
     * @memberof GrantsRequest
     */
    'grant_products': Array<GrantProductRequest>;
}


/**
 * 
 * @export
 * @interface GrantsResponse
 */
export interface GrantsResponse {
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'grant_id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'recipient': string;
    /**
     * 
     * @type {GrantStatusEnum}
     * @memberof GrantsResponse
     */
    'status': GrantStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'expiration_date': string;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'shipment_id': string | null;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof GrantsResponse
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantsResponse
     */
    'created_by': string;
}


/**
 * 
 * @export
 * @interface GrantsResultSet
 */
export interface GrantsResultSet {
    /**
     * 
     * @type {number}
     * @memberof GrantsResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GrantsResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<GrantsResponse>}
     * @memberof GrantsResultSet
     */
    'grants': Array<GrantsResponse>;
}
/**
 * 
 * @export
 * @interface GrantsResultSetAllOf
 */
export interface GrantsResultSetAllOf {
    /**
     * 
     * @type {Array<GrantsResponse>}
     * @memberof GrantsResultSetAllOf
     */
    'grants': Array<GrantsResponse>;
}
/**
 * 
 * @export
 * @interface InventoryAllocationCollectionResponse
 */
export interface InventoryAllocationCollectionResponse {
    /**
     * 
     * @type {Array<InventoryAllocationResponse>}
     * @memberof InventoryAllocationCollectionResponse
     */
    'allocations': Array<InventoryAllocationResponse>;
}
/**
 * 
 * @export
 * @interface InventoryAllocationResponse
 */
export interface InventoryAllocationResponse {
    /**
     * 
     * @type {number}
     * @memberof InventoryAllocationResponse
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof InventoryAllocationResponse
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof InventoryAllocationResponse
     */
    'customization_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryAllocationResponse
     */
    'remaining_allocated_inventory': number;
}
/**
 * 1 = YubiKey Shipment (outright purchase) 2 = YubiKey Tier SKU Shipment (purchase of virtual keys) 3 = Subscription - Initial Shipment (Subscription) 4 = Subscription - Buffer Stock Shipment (Subscription) 5 = Subscription - Replacement YubiKey Shipment (Subscription) 
 * @export
 * @enum {string}
 */

export enum InventoryTypeEnum {
    YubiKeyShipment = 1,
    YubiKeyTierSKUShipment = 2,
    SubscriptionInitialShipment = 3,
    SubscriptionBufferStockShipment = 4,
    SubscriptionReplacementShipment = 5
}


/**
 * See more details at https://console.yubico.com/help/single-req.html#shipment-request-field-limitations
 * @export
 * @interface MailingAddress
 */
export interface MailingAddress {
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     * @deprecated
     */
    'street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof MailingAddress
     */
    'country_code_2'?: string;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'notification_id': string;
    /**
     * 
     * @type {NotificationStatus}
     * @memberof Notification
     */
    'status': NotificationStatus;
    /**
     * 
     * @type {NotificationType}
     * @memberof Notification
     */
    'type': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'message': string;
    /**
     * 
     * @type {Array<NotificationAudience>}
     * @memberof Notification
     */
    'audiences': Array<NotificationAudience>;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'expires_at': string;
    /**
     * 
     * @type {Array<NotificationLink>}
     * @memberof Notification
     */
    'links': Array<NotificationLink>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationAction {
    Read = 'read',
    Archive = 'archive',
    Unarchive = 'unarchive',
    Unread = 'unread'
}


/**
 * 
 * @export
 * @interface NotificationActionRequest
 */
export interface NotificationActionRequest {
    /**
     * 
     * @type {Array<NotificationActionRequestActionsInner>}
     * @memberof NotificationActionRequest
     */
    'actions'?: Array<NotificationActionRequestActionsInner>;
}
/**
 * 
 * @export
 * @interface NotificationActionRequestActionsInner
 */
export interface NotificationActionRequestActionsInner {
    /**
     * 
     * @type {string}
     * @memberof NotificationActionRequestActionsInner
     */
    'notification_id': string;
    /**
     * 
     * @type {NotificationAction}
     * @memberof NotificationActionRequestActionsInner
     */
    'action': NotificationAction;
}


/**
 * 
 * @export
 * @interface NotificationAudience
 */
export interface NotificationAudience {
    /**
     * 
     * @type {NotificationAudienceType}
     * @memberof NotificationAudience
     */
    'audience': NotificationAudienceType;
    /**
     * 
     * @type {string}
     * @memberof NotificationAudience
     */
    'organization_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAudience
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationAudience
     */
    'email'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationAudienceType {
    YedAll = 'yed-all',
    YedEnterprise = 'yed-enterprise',
    YedService = 'yed-service',
    YedOrg = 'yed-org',
    YedOrgUser = 'yed-org-user',
    YedUser = 'yed-user',
    Email = 'email'
}


/**
 * 
 * @export
 * @interface NotificationLink
 */
export interface NotificationLink {
    /**
     * 
     * @type {string}
     * @memberof NotificationLink
     */
    'display_text': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationLink
     */
    'link': string;
    /**
     * 
     * @type {NotificationLinkType}
     * @memberof NotificationLink
     */
    'type': NotificationLinkType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationLinkType {
    Link = 'link',
    Download = 'download'
}


/**
 * 
 * @export
 * @interface NotificationResultSet
 */
export interface NotificationResultSet {
    /**
     * 
     * @type {number}
     * @memberof NotificationResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationResultSet
     */
    'unread'?: number;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof NotificationResultSet
     */
    'notifications': Array<Notification>;
}
/**
 * 
 * @export
 * @interface NotificationResultSetAllOf
 */
export interface NotificationResultSetAllOf {
    /**
     * 
     * @type {number}
     * @memberof NotificationResultSetAllOf
     */
    'unread'?: number;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof NotificationResultSetAllOf
     */
    'notifications': Array<Notification>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationStatus {
    Unread = 'unread',
    Read = 'read',
    Archived = 'archived'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationType {
    Urgent = 'urgent',
    Error = 'error',
    Warning = 'warning',
    Info = 'info',
    Success = 'success'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationView {
    Nonarchived = 'nonarchived',
    UnreadOnly = 'unread-only',
    ReadOnly = 'read-only',
    ArchivedOnly = 'archived-only'
}


/**
 * 
 * @export
 * @interface OrgRelationshipsCreateRequest
 */
export interface OrgRelationshipsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrgRelationshipsCreateRequest
     */
    'organization_id': string;
}
/**
 * 
 * @export
 * @interface OrgRelationshipsResponse
 */
export interface OrgRelationshipsResponse {
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof OrgRelationshipsResponse
     */
    'lower_tier_organization': OrganizationIdAndName;
    /**
     * 
     * @type {boolean}
     * @memberof OrgRelationshipsResponse
     */
    'is_allowed': boolean;
}
/**
 * 
 * @export
 * @interface OrgRelationshipsResponseSet
 */
export interface OrgRelationshipsResponseSet {
    /**
     * 
     * @type {number}
     * @memberof OrgRelationshipsResponseSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof OrgRelationshipsResponseSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<OrgRelationshipsResponse>}
     * @memberof OrgRelationshipsResponseSet
     */
    'relationships': Array<OrgRelationshipsResponse>;
}
/**
 * 
 * @export
 * @interface OrgRelationshipsResponseSetAllOf
 */
export interface OrgRelationshipsResponseSetAllOf {
    /**
     * 
     * @type {Array<OrgRelationshipsResponse>}
     * @memberof OrgRelationshipsResponseSetAllOf
     */
    'relationships': Array<OrgRelationshipsResponse>;
}
/**
 * 
 * @export
 * @interface OrganizationIdAndName
 */
export interface OrganizationIdAndName {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdAndName
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdAndName
     */
    'organization_name': string;
}
/**
 * 
 * @export
 * @interface PaginationFields
 */
export interface PaginationFields {
    /**
     * 
     * @type {number}
     * @memberof PaginationFields
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationFields
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface PartnerPurchaseOrderResponse
 */
export interface PartnerPurchaseOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'closing_city'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'closing_country_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'closing_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'closing_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'closing_country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponse
     */
    'is_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponse
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponse
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponse
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'vat_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponse
     */
    'allow_automated_shipments': boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'key_contact_phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'order_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'organization_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'organizations_shippingaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'organizations_taxaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'organizations_vataccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'purchaseorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'yubicoorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'yubicoinvoice_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'purchaseorder_state_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'purchaseorder_state_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'shipping_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'shipping_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'tax_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'tax_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'total_keys_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'total_keys_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'vat_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'vat_credit_remaining'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponse
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponse
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponse
     */
    'order_closing_date'?: string;
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof PartnerPurchaseOrderResponse
     */
    'reseller': OrganizationIdAndName;
    /**
     * 
     * @type {PartnerPurchaseOrderResponseSummaryAllOfDistributor}
     * @memberof PartnerPurchaseOrderResponse
     */
    'distributor': PartnerPurchaseOrderResponseSummaryAllOfDistributor | null;
    /**
     * 
     * @type {Array<PurchaseOrderProductResponse>}
     * @memberof PartnerPurchaseOrderResponse
     */
    'order_items'?: Array<PurchaseOrderProductResponse>;
}
/**
 * 
 * @export
 * @interface PartnerPurchaseOrderResponseAllOf
 */
export interface PartnerPurchaseOrderResponseAllOf {
    /**
     * 
     * @type {Array<PurchaseOrderProductResponse>}
     * @memberof PartnerPurchaseOrderResponseAllOf
     */
    'order_items'?: Array<PurchaseOrderProductResponse>;
}
/**
 * 
 * @export
 * @interface PartnerPurchaseOrderResponseSet
 */
export interface PartnerPurchaseOrderResponseSet {
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<PartnerPurchaseOrderResponseSummary>}
     * @memberof PartnerPurchaseOrderResponseSet
     */
    'purchaseorders': Array<PartnerPurchaseOrderResponseSummary>;
}
/**
 * 
 * @export
 * @interface PartnerPurchaseOrderResponseSetAllOf
 */
export interface PartnerPurchaseOrderResponseSetAllOf {
    /**
     * 
     * @type {Array<PartnerPurchaseOrderResponseSummary>}
     * @memberof PartnerPurchaseOrderResponseSetAllOf
     */
    'purchaseorders': Array<PartnerPurchaseOrderResponseSummary>;
}
/**
 * 
 * @export
 * @interface PartnerPurchaseOrderResponseSummary
 */
export interface PartnerPurchaseOrderResponseSummary {
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'closing_city'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'closing_country_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'closing_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'closing_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'closing_country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'is_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'vat_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'allow_automated_shipments': boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'key_contact_phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'order_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'organization_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'organizations_shippingaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'organizations_taxaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'organizations_vataccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'purchaseorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'yubicoorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'yubicoinvoice_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'purchaseorder_state_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'purchaseorder_state_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'shipping_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'shipping_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'tax_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'tax_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'total_keys_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'total_keys_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'vat_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'vat_credit_remaining'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'override_shipping_key_limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'order_closing_date'?: string;
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'reseller': OrganizationIdAndName;
    /**
     * 
     * @type {PartnerPurchaseOrderResponseSummaryAllOfDistributor}
     * @memberof PartnerPurchaseOrderResponseSummary
     */
    'distributor': PartnerPurchaseOrderResponseSummaryAllOfDistributor | null;
}
/**
 * 
 * @export
 * @interface PartnerPurchaseOrderResponseSummaryAllOf
 */
export interface PartnerPurchaseOrderResponseSummaryAllOf {
    /**
     * 
     * @type {PartnerPurchaseOrderResponseSummaryAllOfDistributor}
     * @memberof PartnerPurchaseOrderResponseSummaryAllOf
     */
    'distributor': PartnerPurchaseOrderResponseSummaryAllOfDistributor | null;
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof PartnerPurchaseOrderResponseSummaryAllOf
     */
    'reseller': OrganizationIdAndName;
}
/**
 * 
 * @export
 * @interface PartnerPurchaseOrderResponseSummaryAllOfDistributor
 */
export interface PartnerPurchaseOrderResponseSummaryAllOfDistributor {
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummaryAllOfDistributor
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPurchaseOrderResponseSummaryAllOfDistributor
     */
    'organization_name': string;
}
/**
 * Passkey security compliance level. Default=3
 * @export
 * @enum {string}
 */

export enum PasskeyComplianceLevel {
    None = 0,
    Level1 = 1,
    Level2 = 2
}


/**
 * An object containing a list of permissions. Note: the list may contain permissions not yet available in the generated enums, but should be ignorable as the caller will not make use of them. 
 * @export
 * @interface PermissionsObject
 */
export interface PermissionsObject {
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionsObject
     */
    'permissions': Array<string>;
}
/**
 * A compact representation of a predefined role
 * @export
 * @interface PredefinedRole
 */
export interface PredefinedRole {
    /**
     * 
     * @type {string}
     * @memberof PredefinedRole
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PredefinedRole
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PredefinedRole
     */
    'permissions': Array<string>;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_code': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_sku': string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'product_tier': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'product_image': string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'product_is_active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'product_is_available': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     * @deprecated
     */
    'product_availability_message': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'ro_stock_number': string;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof Product
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof Product
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_subscription_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_virtual_product': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_default': boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'customization_id': string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Product
     */
    'product_mapping': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'is_customizable': boolean;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'netsuite_id_standard'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'netsuite_id_custom'?: number | null;
}


/**
 * 
 * @export
 * @interface ProductCustomizationSummary
 */
export interface ProductCustomizationSummary {
    /**
     * A null customization_id represents a standard product (non-customized)
     * @type {string}
     * @memberof ProductCustomizationSummary
     */
    'customization_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductCustomizationSummary
     */
    'quantity_total': number;
    /**
     * Amount remaining of this product with this customization_id
     * @type {number}
     * @memberof ProductCustomizationSummary
     */
    'quantity_remaining': number;
}
/**
 * 
 * @export
 * @interface ProductResultSet
 */
export interface ProductResultSet {
    /**
     * 
     * @type {number}
     * @memberof ProductResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ProductResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductResultSet
     */
    'products': Array<Product>;
}
/**
 * 
 * @export
 * @interface ProductResultSetAllOf
 */
export interface ProductResultSetAllOf {
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductResultSetAllOf
     */
    'products': Array<Product>;
}
/**
 * 
 * @export
 * @interface ProductSummary
 */
export interface ProductSummary {
    /**
     * 
     * @type {number}
     * @memberof ProductSummary
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ProductSummary
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductSummary
     */
    'product_image': string;
    /**
     * 
     * @type {InventoryTypeEnum}
     * @memberof ProductSummary
     */
    'inventory_type': InventoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductSummary
     */
    'quantity_total': number;
    /**
     * Avoid relying on this number; it is not very helpful if the product comes with multiple customizations. In those cases, this value represents the minimum remaining amount, that is the amount remaining of the customization with the least amount of inventory left. 
     * @type {number}
     * @memberof ProductSummary
     */
    'quantity_remaining': number;
    /**
     * 
     * @type {Array<ProductCustomizationSummary>}
     * @memberof ProductSummary
     */
    'customizations'?: Array<ProductCustomizationSummary>;
}


/**
 * 0: No tier 1: Base tier 2: Advanced tier 3: Premium tier 4: FIPS tier 5: Base tier (subscription 2.0) 6: Base/Bio tier (subscription 2.0) 7: Advanced tier (subscription 2.0) 8: Advanced/Bio tier (subscription 2.0) 9: Compliance tier (subscription 2.0) 
 * @export
 * @enum {string}
 */

export enum ProductTierEnum {
    NoTier = 0,
    BaseTier = 1,
    AdvancedTier = 2,
    PremiumTier = 3,
    FIPSTier = 4,
    Sub2BaseTier = 5,
    Sub2BaseBioTier = 6,
    Sub2AdvancedTier = 7,
    Sub2AdvancedBioTier = 8,
    Sub2ComplianceTier = 9
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum ProductTypeEnum {
    Subscription = 'Subscription',
    YubiKey = 'YubiKey',
    Accessory = 'Accessory'
}


/**
 * 
 * @export
 * @interface PurchaseOrderProductResponse
 */
export interface PurchaseOrderProductResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductResponse
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_product_quantity': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_product_quantity_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderProductResponse
     */
    'purchaseorder_product_cost': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseOrderProductResponse
     */
    'customizations': Array<string>;
}
/**
 * 
 * @export
 * @interface PurchaseOrderResponse
 */
export interface PurchaseOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'channelpartner_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'channelpartner_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_city'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'closing_country_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_street_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_street_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     * @deprecated
     */
    'closing_street_line3'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'closing_country_code_2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_post_pay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_tax_exempt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_vat_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'vat_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'allow_automated_shipments': boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'key_contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'key_contact_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'key_contact_phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'order_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     * @deprecated
     */
    'organization_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'organization_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'organizations_shippingaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'organizations_taxaccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'organizations_vataccount_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'purchaseorder_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'purchaseorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'yubicoorder_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'yubicoinvoice_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOrderResponse
     */
    'purchaseorder_state_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'purchaseorder_state_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'shipping_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'shipping_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'tax_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'tax_credit_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'total_keys_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'total_keys_remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'vat_credit_purchased'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'vat_credit_remaining'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOrderResponse
     */
    'is_override_shipping'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'override_shipping_charge'?: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderResponse
     */
    'override_shipping_key_limit'?: number;
}
/**
 * 
 * @export
 * @interface ResellerCustomerViewResponse
 */
export interface ResellerCustomerViewResponse {
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof ResellerCustomerViewResponse
     */
    'customer': OrganizationIdAndName;
    /**
     * 
     * @type {DashboardResponse}
     * @memberof ResellerCustomerViewResponse
     */
    'inventory_summary': DashboardResponse;
}
/**
 * 
 * @export
 * @interface ResellerViewResponse
 */
export interface ResellerViewResponse {
    /**
     * 
     * @type {Array<ResellerViewResponseItem>}
     * @memberof ResellerViewResponse
     */
    'reseller_view_items': Array<ResellerViewResponseItem>;
}
/**
 * 
 * @export
 * @interface ResellerViewResponseItem
 */
export interface ResellerViewResponseItem {
    /**
     * 
     * @type {OrganizationIdAndName}
     * @memberof ResellerViewResponseItem
     */
    'customer': OrganizationIdAndName;
    /**
     * 
     * @type {number}
     * @memberof ResellerViewResponseItem
     */
    'purchaseorder_count': number;
}
/**
 * 
 * @export
 * @interface ResellerViewResultSet
 */
export interface ResellerViewResultSet {
    /**
     * 
     * @type {number}
     * @memberof ResellerViewResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ResellerViewResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<ResellerViewResponseItem>}
     * @memberof ResellerViewResultSet
     */
    'reseller_view_items': Array<ResellerViewResponseItem>;
}
/**
 * 
 * @export
 * @interface SearchDescription
 */
export interface SearchDescription {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescription
     */
    'basic': Array<string>;
    /**
     * 
     * @type {Array<SearchDescriptionAdvanced>}
     * @memberof SearchDescription
     */
    'advanced': Array<SearchDescriptionAdvanced>;
}
/**
 * 
 * @export
 * @interface SearchDescriptionAdvanced
 */
export interface SearchDescriptionAdvanced {
    /**
     * 
     * @type {string}
     * @memberof SearchDescriptionAdvanced
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchDescriptionAdvanced
     */
    'type': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescriptionAdvanced
     */
    'operations': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchDescriptionAdvanced
     */
    'select_values'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ShipmentDebitAllocationResponse
 */
export interface ShipmentDebitAllocationResponse {
    /**
     * 
     * @type {number}
     * @memberof ShipmentDebitAllocationResponse
     */
    'product_id': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentDebitAllocationResponse
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDebitAllocationResponse
     */
    'inventory_allocation_id': string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentDebitAllocationResponse
     */
    'inventory_allocation_amount': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentDebitAllocationResponse
     */
    'per_unit_product_cost': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDebitAllocationResponse
     */
    'purchaseorder_number': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDebitAllocationResponse
     */
    'purchaseorder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDebitAllocationResponse
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDebitAllocationResponse
     */
    'inventory_product_name': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDebitAllocationResponse
     */
    'shipment_product_id': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentDebitAllocationResponse
     */
    'customization_id': string | null;
}
/**
 * 
 * @export
 * @interface ShipmentDebitAllocationResultSet
 */
export interface ShipmentDebitAllocationResultSet {
    /**
     * 
     * @type {number}
     * @memberof ShipmentDebitAllocationResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentDebitAllocationResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<ShipmentDebitAllocationResponse>}
     * @memberof ShipmentDebitAllocationResultSet
     */
    'shipment_allocations': Array<ShipmentDebitAllocationResponse>;
}
/**
 * 
 * @export
 * @interface ShipmentDebitAllocationResultSetAllOf
 */
export interface ShipmentDebitAllocationResultSetAllOf {
    /**
     * 
     * @type {Array<ShipmentDebitAllocationResponse>}
     * @memberof ShipmentDebitAllocationResultSetAllOf
     */
    'shipment_allocations': Array<ShipmentDebitAllocationResponse>;
}
/**
 * Type of delivery service requested, 1 for normal (standard) shipping or 2 for expedited (rush) shipping. Default=1.
 * @export
 * @enum {string}
 */

export enum ShipmentDeliveryTypeEnum {
    Standard = 1,
    Expedited = 2
}


/**
 * 
 * @export
 * @interface ShipmentItem
 */
export interface ShipmentItem {
    /**
     * 
     * @type {number}
     * @memberof ShipmentItem
     */
    'product_id': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    'customization_id': string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentItem
     */
    'inventory_product_id': number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentItem
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface ShipmentRequest
 */
export interface ShipmentRequest {
    /**
     * 
     * @type {number}
     * @memberof ShipmentRequest
     */
    'channelpartner_id': number;
    /**
     * 
     * @type {ShipmentDeliveryTypeEnum}
     * @memberof ShipmentRequest
     */
    'delivery_type': ShipmentDeliveryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentRequest
     */
    'address_validation_bypass'?: boolean;
    /**
     * 
     * @type {Array<ShipmentItem>}
     * @memberof ShipmentRequest
     */
    'shipment_items': Array<ShipmentItem>;
}


/**
 * See more details at https://console.yubico.com/help/Best_Practices_and_Troubleshooting.html#shipping-status-codes.
 * @export
 * @interface ShipmentState
 */
export interface ShipmentState {
    /**
     * 
     * @type {number}
     * @memberof ShipmentState
     */
    'shipment_state_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentState
     */
    'shipment_state_message'?: string;
}
/**
 * 
 * @export
 * @interface ShipmentStateResponse
 */
export interface ShipmentStateResponse {
    /**
     * 
     * @type {number}
     * @memberof ShipmentStateResponse
     */
    'shipment_state_id': number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentStateResponse
     */
    'shipment_state_message': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentStateResponse
     */
    'shipment_state_code': string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentStateResponse
     */
    'shipment_state_description': string;
}
/**
 * 
 * @export
 * @interface StandardErrorDetail
 */
export interface StandardErrorDetail {
    /**
     * The message explaining the detailed error in text.
     * @type {string}
     * @memberof StandardErrorDetail
     */
    'message': string;
    /**
     * json path to the field, if the error detail refers to a field
     * @type {string}
     * @memberof StandardErrorDetail
     */
    'field'?: string;
}
/**
 * 
 * @export
 * @interface StandardErrorResult
 */
export interface StandardErrorResult {
    /**
     * 
     * @type {string}
     * @memberof StandardErrorResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof StandardErrorResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof StandardErrorResult
     */
    'errors'?: Array<StandardErrorDetail>;
}
/**
 * 
 * @export
 * @interface SubscriptionSummary
 */
export interface SubscriptionSummary {
    /**
     * 
     * @type {ProductTierEnum}
     * @memberof SubscriptionSummary
     */
    'product_tier': ProductTierEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof SubscriptionSummary
     */
    'subscription_type': SubscriptionTypeEnum;
    /**
     * Ordered by inventory type (initial first, then buffer, then replacement) 
     * @type {Array<ProductSummary>}
     * @memberof SubscriptionSummary
     */
    'products': Array<ProductSummary>;
}


/**
 * 0: N/A (no subscription) 1: Primary subscription 2: Backup subscription 3: Primary Standard subscription 2.0 4: Backup Standard subscription 2.0 5: Primary Plus subscription 2.0 6: Backup Plus subscription 2.0 
 * @export
 * @enum {string}
 */

export enum SubscriptionTypeEnum {
    NoSubscription = 0,
    PrimarySubscription = 1,
    BackupSubscription = 2,
    Sub2PrimaryStandard = 3,
    Sub2BackupStandard = 4,
    Sub2PrimaryPlus = 5,
    Sub2BackupPlus = 6
}


/**
 * 
 * @export
 * @interface Tracking
 */
export interface Tracking {
    /**
     * 
     * @type {CarrierIdentifierEnum}
     * @memberof Tracking
     */
    'carrier'?: CarrierIdentifierEnum;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    'tracking_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    'tracking_link'?: string;
}


/**
 * 
 * @export
 * @interface UploadResponse
 */
export interface UploadResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    'upload_id': string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    'status': UploadResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    'hash': string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    'uploader'?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadResponse
     */
    'pending': number;
    /**
     * 
     * @type {number}
     * @memberof UploadResponse
     */
    'error': number;
    /**
     * 
     * @type {number}
     * @memberof UploadResponse
     */
    'processed': number;
}

/**
    * @export
    * @enum {string}
    */
export enum UploadResponseStatusEnum {
    Processing = 'processing',
    Processed = 'processed'
}

/**
 * 
 * @export
 * @interface UploadResultSet
 */
export interface UploadResultSet {
    /**
     * 
     * @type {number}
     * @memberof UploadResultSet
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof UploadResultSet
     */
    'total_count': number;
    /**
     * 
     * @type {Array<UploadResponse>}
     * @memberof UploadResultSet
     */
    'uploads': Array<UploadResponse>;
}
/**
 * 
 * @export
 * @interface UploadResultSetAllOf
 */
export interface UploadResultSetAllOf {
    /**
     * 
     * @type {Array<UploadResponse>}
     * @memberof UploadResultSetAllOf
     */
    'uploads': Array<UploadResponse>;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ValidationError
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ValidationError
     */
    'errors'?: Array<StandardErrorDetail>;
}

/**
 * BannersApi - axios parameter creator
 * @export
 */
export const BannersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get informational banners published in the service for the current target audience
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanners: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BannersApi - functional programming interface
 * @export
 */
export const BannersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BannersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get informational banners published in the service for the current target audience
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBanners(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BannerMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBanners(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BannersApi - factory interface
 * @export
 */
export const BannersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BannersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get informational banners published in the service for the current target audience
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanners(options?: any): AxiosPromise<Array<BannerMessage>> {
            return localVarFp.getBanners(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BannersApi - object-oriented interface
 * @export
 * @class BannersApi
 * @extends {BaseAPI}
 */
export class BannersApi extends BaseAPI {
    /**
     * 
     * @summary Get informational banners published in the service for the current target audience
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    public getBanners(options?: AxiosRequestConfig) {
        return BannersApiFp(this.configuration).getBanners(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomizationsApi - axios parameter creator
 * @export
 */
export const CustomizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves all history events for a given customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomizationHistory: async (customizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customizationId' is not null or undefined
            assertParamExists('getCustomizationHistory', 'customizationId', customizationId)
            const localVarPath = `/v1/customizations/{customizationId}/history`
                .replace(`{${"customizationId"}}`, encodeURIComponent(String(customizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomizationsApi - functional programming interface
 * @export
 */
export const CustomizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves all history events for a given customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomizationHistory(customizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomizationHistoryResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomizationHistory(customizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomizationsApi - factory interface
 * @export
 */
export const CustomizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves all history events for a given customization
         * @param {string} customizationId ID of the Customization for which the inventory is being fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomizationHistory(customizationId: string, options?: any): AxiosPromise<Array<CustomizationHistoryResponseInner>> {
            return localVarFp.getCustomizationHistory(customizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomizationsApi - object-oriented interface
 * @export
 * @class CustomizationsApi
 * @extends {BaseAPI}
 */
export class CustomizationsApi extends BaseAPI {
    /**
     * 
     * @summary Retrieves all history events for a given customization
     * @param {string} customizationId ID of the Customization for which the inventory is being fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationsApi
     */
    public getCustomizationHistory(customizationId: string, options?: AxiosRequestConfig) {
        return CustomizationsApiFp(this.configuration).getCustomizationHistory(customizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get inventory summary for the current organization
         * @summary Get organization dashboard
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationDashboard: async (shippableOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (shippableOnly !== undefined) {
                localVarQueryParameter['shippable_only'] = shippableOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Get inventory summary for the current organization
         * @summary Get organization dashboard
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationDashboard(shippableOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationDashboard(shippableOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * Get inventory summary for the current organization
         * @summary Get organization dashboard
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationDashboard(shippableOnly?: boolean, options?: any): AxiosPromise<DashboardResponse> {
            return localVarFp.getOrganizationDashboard(shippableOnly, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * Get inventory summary for the current organization
     * @summary Get organization dashboard
     * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getOrganizationDashboard(shippableOnly?: boolean, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getOrganizationDashboard(shippableOnly, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DistributorApi - axios parameter creator
 * @export
 */
export const DistributorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves end customer purchase order and product information aquired through distributor\'s reseller partner
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDashboardAsDistributor: async (customerOrganizationId: string, resellerOrganizationId: string, shippableOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getCustomerDashboardAsDistributor', 'customerOrganizationId', customerOrganizationId)
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('getCustomerDashboardAsDistributor', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/distributor/resellers/{resellerOrganizationId}/customers/{customerOrganizationId}`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)))
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (shippableOnly !== undefined) {
                localVarQueryParameter['shippable_only'] = shippableOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProductsAsDistributor: async (customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getCustomerProductsAsDistributor', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/distributor/customers/{customerOrganizationId}/products`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a purchase order attributed to current distributor organization
         * @summary Get a distributor purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorPurchaseOrderById: async (purchaseorderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderId' is not null or undefined
            assertParamExists('getDistributorPurchaseOrderById', 'purchaseorderId', purchaseorderId)
            const localVarPath = `/v1/distributor/purchaseorders/{purchaseorderId}`
                .replace(`{${"purchaseorderId"}}`, encodeURIComponent(String(purchaseorderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all purchase orders attributed to current distributor organization
         * @summary Get distributor purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorPurchaseOrders: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/purchaseorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get purchase order summary for the current distributor organization
         * @summary Get distributor view
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorView: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of relationships on distributor
         * @summary Get list of relationships on distributor
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipsOnDistributor: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant visibility of inventory to a reseller organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantResellerVisilibity: async (orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orgRelationshipsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributorRelationshipsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/relationships/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes distributor view searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributorViewSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke the visilibity of inventory of a reseller organization
         * @summary Revoke inventory visibility of organization
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeResellerVisibility: async (resellerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('revokeResellerVisibility', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/distributor/relationships/{resellerOrganizationId}`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DistributorApi - functional programming interface
 * @export
 */
export const DistributorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DistributorApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves end customer purchase order and product information aquired through distributor\'s reseller partner
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDashboardAsDistributor(customerOrganizationId: string, resellerOrganizationId: string, shippableOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributorCustomerViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDashboardAsDistributor(customerOrganizationId, resellerOrganizationId, shippableOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerProductsAsDistributor(customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerProductsAsDistributor(customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a purchase order attributed to current distributor organization
         * @summary Get a distributor purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistributorPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPurchaseOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistributorPurchaseOrderById(purchaseorderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all purchase orders attributed to current distributor organization
         * @summary Get distributor purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistributorPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPurchaseOrderResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistributorPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get purchase order summary for the current distributor organization
         * @summary Get distributor view
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistributorView(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributorViewResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistributorView(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of relationships on distributor
         * @summary Get list of relationships on distributor
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipsOnDistributor(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRelationshipsResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipsOnDistributor(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grant visibility of inventory to a reseller organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantResellerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRelationshipsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantResellerVisilibity(orgRelationshipsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDistributorRelationshipsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDistributorRelationshipsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes distributor view searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDistributorViewSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDistributorViewSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Revoke the visilibity of inventory of a reseller organization
         * @summary Revoke inventory visibility of organization
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeResellerVisibility(resellerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeResellerVisibility(resellerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DistributorApi - factory interface
 * @export
 */
export const DistributorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DistributorApiFp(configuration)
    return {
        /**
         * Retrieves end customer purchase order and product information aquired through distributor\'s reseller partner
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDashboardAsDistributor(customerOrganizationId: string, resellerOrganizationId: string, shippableOnly?: boolean, options?: any): AxiosPromise<DistributorCustomerViewResponse> {
            return localVarFp.getCustomerDashboardAsDistributor(customerOrganizationId, resellerOrganizationId, shippableOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProductsAsDistributor(customerOrganizationId: string, options?: any): AxiosPromise<ProductResultSet> {
            return localVarFp.getCustomerProductsAsDistributor(customerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a purchase order attributed to current distributor organization
         * @summary Get a distributor purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorPurchaseOrderById(purchaseorderId: string, options?: any): AxiosPromise<PartnerPurchaseOrderResponse> {
            return localVarFp.getDistributorPurchaseOrderById(purchaseorderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all purchase orders attributed to current distributor organization
         * @summary Get distributor purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<PartnerPurchaseOrderResponseSet> {
            return localVarFp.getDistributorPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get purchase order summary for the current distributor organization
         * @summary Get distributor view
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorView(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<DistributorViewResultSet> {
            return localVarFp.getDistributorView(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of relationships on distributor
         * @summary Get list of relationships on distributor
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipsOnDistributor(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<OrgRelationshipsResponseSet> {
            return localVarFp.getRelationshipsOnDistributor(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant visibility of inventory to a reseller organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantResellerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: any): AxiosPromise<OrgRelationshipsResponse> {
            return localVarFp.grantResellerVisilibity(orgRelationshipsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributorRelationshipsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listDistributorRelationshipsSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes distributor view searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributorViewSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listDistributorViewSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke the visilibity of inventory of a reseller organization
         * @summary Revoke inventory visibility of organization
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeResellerVisibility(resellerOrganizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.revokeResellerVisibility(resellerOrganizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DistributorApi - object-oriented interface
 * @export
 * @class DistributorApi
 * @extends {BaseAPI}
 */
export class DistributorApi extends BaseAPI {
    /**
     * Retrieves end customer purchase order and product information aquired through distributor\'s reseller partner
     * @summary retrieve end customer dashbaord details
     * @param {string} customerOrganizationId end customer organization id
     * @param {string} resellerOrganizationId reseller organization id
     * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public getCustomerDashboardAsDistributor(customerOrganizationId: string, resellerOrganizationId: string, shippableOnly?: boolean, options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).getCustomerDashboardAsDistributor(customerOrganizationId, resellerOrganizationId, shippableOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the information of all products of an end customer
     * @summary retrieve end customer products
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public getCustomerProductsAsDistributor(customerOrganizationId: string, options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).getCustomerProductsAsDistributor(customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a purchase order attributed to current distributor organization
     * @summary Get a distributor purchase order by id
     * @param {string} purchaseorderId ID of purchase order that needs to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public getDistributorPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).getDistributorPurchaseOrderById(purchaseorderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all purchase orders attributed to current distributor organization
     * @summary Get distributor purchase orders
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public getDistributorPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).getDistributorPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get purchase order summary for the current distributor organization
     * @summary Get distributor view
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public getDistributorView(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).getDistributorView(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of relationships on distributor
     * @summary Get list of relationships on distributor
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public getRelationshipsOnDistributor(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).getRelationshipsOnDistributor(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant visibility of inventory to a reseller organization
     * @summary Grant inventory visibility to organization
     * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public grantResellerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).grantResellerVisilibity(orgRelationshipsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes distributor relationships searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public listDistributorRelationshipsSearchDescription(options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).listDistributorRelationshipsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes distributor view searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public listDistributorViewSearchDescription(options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).listDistributorViewSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke the visilibity of inventory of a reseller organization
     * @summary Revoke inventory visibility of organization
     * @param {string} resellerOrganizationId reseller organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributorApi
     */
    public revokeResellerVisibility(resellerOrganizationId: string, options?: AxiosRequestConfig) {
        return DistributorApiFp(this.configuration).revokeResellerVisibility(resellerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmailTemplatesApi - axios parameter creator
 * @export
 */
export const EmailTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the default email template for the given template type.
         * @summary Get a single default email template
         * @param {string} templateType type of template to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultTemplate: async (templateType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateType' is not null or undefined
            assertParamExists('getDefaultTemplate', 'templateType', templateType)
            const localVarPath = `/v1/email-templates/{templateType}`
                .replace(`{${"templateType"}}`, encodeURIComponent(String(templateType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the default email templates
         * @summary Get all default email templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultTemplates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the email template for template type for a given organization.
         * @summary Get a single email template for org
         * @param {string} templateType type of template to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTemplate: async (templateType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateType' is not null or undefined
            assertParamExists('getOrganizationTemplate', 'templateType', templateType)
            const localVarPath = `/v1/organization/email-templates/{templateType}`
                .replace(`{${"templateType"}}`, encodeURIComponent(String(templateType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all email templates for a given organization.
         * @summary Get all email templates for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTemplates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/organization/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the email template for template type for a given organization.
         * @summary update email template for org
         * @param {string} templateType type of template to be fetched
         * @param {EmailTemplateRequest} [emailTemplateRequest] EmailTemplate to be used for the organization for the given template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationTemplate: async (templateType: string, emailTemplateRequest?: EmailTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateType' is not null or undefined
            assertParamExists('updateOrganizationTemplate', 'templateType', templateType)
            const localVarPath = `/v1/organization/email-templates/{templateType}`
                .replace(`{${"templateType"}}`, encodeURIComponent(String(templateType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailTemplatesApi - functional programming interface
 * @export
 */
export const EmailTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the default email template for the given template type.
         * @summary Get a single default email template
         * @param {string} templateType type of template to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultTemplate(templateType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultTemplate(templateType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the default email templates
         * @summary Get all default email templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultTemplates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultTemplates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the email template for template type for a given organization.
         * @summary Get a single email template for org
         * @param {string} templateType type of template to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationTemplate(templateType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationTemplate(templateType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all email templates for a given organization.
         * @summary Get all email templates for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationTemplates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationTemplates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the email template for template type for a given organization.
         * @summary update email template for org
         * @param {string} templateType type of template to be fetched
         * @param {EmailTemplateRequest} [emailTemplateRequest] EmailTemplate to be used for the organization for the given template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationTemplate(templateType: string, emailTemplateRequest?: EmailTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationTemplate(templateType, emailTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailTemplatesApi - factory interface
 * @export
 */
export const EmailTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailTemplatesApiFp(configuration)
    return {
        /**
         * Get the default email template for the given template type.
         * @summary Get a single default email template
         * @param {string} templateType type of template to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultTemplate(templateType: string, options?: any): AxiosPromise<EmailTemplateResponse> {
            return localVarFp.getDefaultTemplate(templateType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the default email templates
         * @summary Get all default email templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultTemplates(options?: any): AxiosPromise<Array<EmailTemplateResponse>> {
            return localVarFp.getDefaultTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the email template for template type for a given organization.
         * @summary Get a single email template for org
         * @param {string} templateType type of template to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTemplate(templateType: string, options?: any): AxiosPromise<EmailTemplateResponse> {
            return localVarFp.getOrganizationTemplate(templateType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all email templates for a given organization.
         * @summary Get all email templates for org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTemplates(options?: any): AxiosPromise<Array<EmailTemplateResponse>> {
            return localVarFp.getOrganizationTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * Update the email template for template type for a given organization.
         * @summary update email template for org
         * @param {string} templateType type of template to be fetched
         * @param {EmailTemplateRequest} [emailTemplateRequest] EmailTemplate to be used for the organization for the given template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationTemplate(templateType: string, emailTemplateRequest?: EmailTemplateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateOrganizationTemplate(templateType, emailTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailTemplatesApi - object-oriented interface
 * @export
 * @class EmailTemplatesApi
 * @extends {BaseAPI}
 */
export class EmailTemplatesApi extends BaseAPI {
    /**
     * Get the default email template for the given template type.
     * @summary Get a single default email template
     * @param {string} templateType type of template to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public getDefaultTemplate(templateType: string, options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).getDefaultTemplate(templateType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the default email templates
     * @summary Get all default email templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public getDefaultTemplates(options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).getDefaultTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the email template for template type for a given organization.
     * @summary Get a single email template for org
     * @param {string} templateType type of template to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public getOrganizationTemplate(templateType: string, options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).getOrganizationTemplate(templateType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all email templates for a given organization.
     * @summary Get all email templates for org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public getOrganizationTemplates(options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).getOrganizationTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the email template for template type for a given organization.
     * @summary update email template for org
     * @param {string} templateType type of template to be fetched
     * @param {EmailTemplateRequest} [emailTemplateRequest] EmailTemplate to be used for the organization for the given template type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public updateOrganizationTemplate(templateType: string, emailTemplateRequest?: EmailTemplateRequest, options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).updateOrganizationTemplate(templateType, emailTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeatureTogglesApi - axios parameter creator
 * @export
 */
export const FeatureTogglesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns feature toggles with default values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultToggles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/feature-toggles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureTogglesApi - functional programming interface
 * @export
 */
export const FeatureTogglesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureTogglesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns feature toggles with default values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultToggles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureToggleCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultToggles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeatureTogglesApi - factory interface
 * @export
 */
export const FeatureTogglesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureTogglesApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns feature toggles with default values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultToggles(options?: any): AxiosPromise<FeatureToggleCollectionResponse> {
            return localVarFp.getDefaultToggles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureTogglesApi - object-oriented interface
 * @export
 * @class FeatureTogglesApi
 * @extends {BaseAPI}
 */
export class FeatureTogglesApi extends BaseAPI {
    /**
     * 
     * @summary Returns feature toggles with default values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureTogglesApi
     */
    public getDefaultToggles(options?: AxiosRequestConfig) {
        return FeatureTogglesApiFp(this.configuration).getDefaultToggles(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GrantsApi - axios parameter creator
 * @export
 */
export const GrantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create grants for the recipients with the given products.
         * @param {GrantsRequest} grantsRequest 
         * @param {File} [recipientsCsv] Required if no recipients list is given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrants: async (grantsRequest: GrantsRequest, recipientsCsv?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantsRequest' is not null or undefined
            assertParamExists('createGrants', 'grantsRequest', grantsRequest)
            const localVarPath = `/v1/grants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


            if (recipientsCsv !== undefined) { 
                localVarFormParams.append('recipients_csv', recipientsCsv as any);
            }
    
            if (grantsRequest !== undefined) { 
                localVarFormParams.append('grants_request', new Blob([JSON.stringify(grantsRequest)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an unclaimed grant.
         * @summary Delete an unclaimed grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGrant: async (grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('deleteGrant', 'grantId', grantId)
            const localVarPath = `/v1/grants/{grantId}`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single grant by ID, including for each product whether it\'s eligible (i.e. active & enabled for the org). 
         * @summary Get grant information
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrantInfoById: async (grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('getGrantInfoById', 'grantId', grantId)
            const localVarPath = `/v1/grants/{grantId}`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all grants
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrants: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/grants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes grants searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGrantsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/grants/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrantsApi - functional programming interface
 * @export
 */
export const GrantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrantsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create grants for the recipients with the given products.
         * @param {GrantsRequest} grantsRequest 
         * @param {File} [recipientsCsv] Required if no recipients list is given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGrants(grantsRequest: GrantsRequest, recipientsCsv?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGrants(grantsRequest, recipientsCsv, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete an unclaimed grant.
         * @summary Delete an unclaimed grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGrant(grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGrant(grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a single grant by ID, including for each product whether it\'s eligible (i.e. active & enabled for the org). 
         * @summary Get grant information
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrantInfoById(grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrantInfoById(grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all grants
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrants(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantsResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrants(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes grants searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGrantsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGrantsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GrantsApi - factory interface
 * @export
 */
export const GrantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrantsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create grants for the recipients with the given products.
         * @param {GrantsRequest} grantsRequest 
         * @param {File} [recipientsCsv] Required if no recipients list is given
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrants(grantsRequest: GrantsRequest, recipientsCsv?: File, options?: any): AxiosPromise<void> {
            return localVarFp.createGrants(grantsRequest, recipientsCsv, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an unclaimed grant.
         * @summary Delete an unclaimed grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGrant(grantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGrant(grantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single grant by ID, including for each product whether it\'s eligible (i.e. active & enabled for the org). 
         * @summary Get grant information
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrantInfoById(grantId: string, options?: any): AxiosPromise<GrantDetailResponse> {
            return localVarFp.getGrantInfoById(grantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all grants
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrants(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<GrantsResultSet> {
            return localVarFp.getGrants(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes grants searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGrantsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listGrantsSearchDescription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrantsApi - object-oriented interface
 * @export
 * @class GrantsApi
 * @extends {BaseAPI}
 */
export class GrantsApi extends BaseAPI {
    /**
     * 
     * @summary Create grants for the recipients with the given products.
     * @param {GrantsRequest} grantsRequest 
     * @param {File} [recipientsCsv] Required if no recipients list is given
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantsApi
     */
    public createGrants(grantsRequest: GrantsRequest, recipientsCsv?: File, options?: AxiosRequestConfig) {
        return GrantsApiFp(this.configuration).createGrants(grantsRequest, recipientsCsv, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an unclaimed grant.
     * @summary Delete an unclaimed grant
     * @param {string} grantId The ID of the grant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantsApi
     */
    public deleteGrant(grantId: string, options?: AxiosRequestConfig) {
        return GrantsApiFp(this.configuration).deleteGrant(grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single grant by ID, including for each product whether it\'s eligible (i.e. active & enabled for the org). 
     * @summary Get grant information
     * @param {string} grantId The ID of the grant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantsApi
     */
    public getGrantInfoById(grantId: string, options?: AxiosRequestConfig) {
        return GrantsApiFp(this.configuration).getGrantInfoById(grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all grants
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantsApi
     */
    public getGrants(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return GrantsApiFp(this.configuration).getGrants(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes grants searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantsApi
     */
    public listGrantsSearchDescription(options?: AxiosRequestConfig) {
        return GrantsApiFp(this.configuration).listGrantsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns products and their quantities available per channel partner for the orgId that corresponds to the token making the request.
         * @summary Returns products and their quantities available for the organization per channel partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOfOrganizationPerChannelPartner: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/inventory/channelpartners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns products and their quantities available per channel partner for the orgId that corresponds to the token making the request.
         * @summary Returns products and their quantities available for the organization per channel partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryOfOrganizationPerChannelPartner(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelPartnerProductInventoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryOfOrganizationPerChannelPartner(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryApiFp(configuration)
    return {
        /**
         * Returns products and their quantities available per channel partner for the orgId that corresponds to the token making the request.
         * @summary Returns products and their quantities available for the organization per channel partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOfOrganizationPerChannelPartner(options?: any): AxiosPromise<ChannelPartnerProductInventoryResponse> {
            return localVarFp.getInventoryOfOrganizationPerChannelPartner(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
    /**
     * Returns products and their quantities available per channel partner for the orgId that corresponds to the token making the request.
     * @summary Returns products and their quantities available for the organization per channel partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public getInventoryOfOrganizationPerChannelPartner(options?: AxiosRequestConfig) {
        return InventoryApiFp(this.configuration).getInventoryOfOrganizationPerChannelPartner(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryAllocationApi - axios parameter creator
 * @export
 */
export const InventoryAllocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get end customer inventory allocations
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAllocationsAsDistributor: async (customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getInventoryAllocationsAsDistributor', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/distributor/customers/{customerOrganizationId}/inventory-allocations`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get end customer inventory allocations
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAllocationsAsReseller: async (customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getInventoryAllocationsAsReseller', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/reseller/customers/{customerOrganizationId}/inventory-allocations`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryAllocationApi - functional programming interface
 * @export
 */
export const InventoryAllocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryAllocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get end customer inventory allocations
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAllocationsAsDistributor(customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryAllocationCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAllocationsAsDistributor(customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get end customer inventory allocations
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryAllocationsAsReseller(customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryAllocationCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryAllocationsAsReseller(customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryAllocationApi - factory interface
 * @export
 */
export const InventoryAllocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryAllocationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get end customer inventory allocations
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAllocationsAsDistributor(customerOrganizationId: string, options?: any): AxiosPromise<InventoryAllocationCollectionResponse> {
            return localVarFp.getInventoryAllocationsAsDistributor(customerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get end customer inventory allocations
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryAllocationsAsReseller(customerOrganizationId: string, options?: any): AxiosPromise<InventoryAllocationCollectionResponse> {
            return localVarFp.getInventoryAllocationsAsReseller(customerOrganizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryAllocationApi - object-oriented interface
 * @export
 * @class InventoryAllocationApi
 * @extends {BaseAPI}
 */
export class InventoryAllocationApi extends BaseAPI {
    /**
     * 
     * @summary Get end customer inventory allocations
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryAllocationApi
     */
    public getInventoryAllocationsAsDistributor(customerOrganizationId: string, options?: AxiosRequestConfig) {
        return InventoryAllocationApiFp(this.configuration).getInventoryAllocationsAsDistributor(customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get end customer inventory allocations
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryAllocationApi
     */
    public getInventoryAllocationsAsReseller(customerOrganizationId: string, options?: AxiosRequestConfig) {
        return InventoryAllocationApiFp(this.configuration).getInventoryAllocationsAsReseller(customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a paginated list of notifications for the current user
         * @summary Fetches notifications
         * @param {NotificationView} [view] Which types of notifications to return
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (view?: NotificationView, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A map of notifications to what action should be performed
         * @summary Perform an action on a set of notifications
         * @param {NotificationActionRequest} [notificationActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performActionOnNotifications: async (notificationActionRequest?: NotificationActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a paginated list of notifications for the current user
         * @summary Fetches notifications
         * @param {NotificationView} [view] Which types of notifications to return
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(view?: NotificationView, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(view, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A map of notifications to what action should be performed
         * @summary Perform an action on a set of notifications
         * @param {NotificationActionRequest} [notificationActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performActionOnNotifications(notificationActionRequest?: NotificationActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performActionOnNotifications(notificationActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * Fetch a paginated list of notifications for the current user
         * @summary Fetches notifications
         * @param {NotificationView} [view] Which types of notifications to return
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(view?: NotificationView, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<NotificationResultSet> {
            return localVarFp.getNotifications(view, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * A map of notifications to what action should be performed
         * @summary Perform an action on a set of notifications
         * @param {NotificationActionRequest} [notificationActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performActionOnNotifications(notificationActionRequest?: NotificationActionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.performActionOnNotifications(notificationActionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * Fetch a paginated list of notifications for the current user
     * @summary Fetches notifications
     * @param {NotificationView} [view] Which types of notifications to return
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(view?: NotificationView, offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotifications(view, offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A map of notifications to what action should be performed
     * @summary Perform an action on a set of notifications
     * @param {NotificationActionRequest} [notificationActionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public performActionOnNotifications(notificationActionRequest?: NotificationActionRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).performActionOnNotifications(notificationActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationApi - axios parameter creator
 * @export
 */
export const OrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the current compliance level of the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetComplianceLevel: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/organization/passkey-compliance-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of org owner User Ids for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetNumOrgOwners: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/organization/owners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets the current compliance level of the organization
         * @param {number} [body] EmailTemplate to be used for the organization for the given template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSetComplianceLevel: async (body?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/organization/passkey-compliance-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationApi - functional programming interface
 * @export
 */
export const OrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the current compliance level of the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationGetComplianceLevel(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasskeyComplianceLevel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationGetComplianceLevel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of org owner User Ids for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationGetNumOrgOwners(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationGetNumOrgOwners(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sets the current compliance level of the organization
         * @param {number} [body] EmailTemplate to be used for the organization for the given template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationSetComplianceLevel(body?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationSetComplianceLevel(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationApi - factory interface
 * @export
 */
export const OrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the current compliance level of the organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetComplianceLevel(options?: any): AxiosPromise<PasskeyComplianceLevel> {
            return localVarFp.organizationGetComplianceLevel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of org owner User Ids for current org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationGetNumOrgOwners(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.organizationGetNumOrgOwners(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets the current compliance level of the organization
         * @param {number} [body] EmailTemplate to be used for the organization for the given template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationSetComplianceLevel(body?: number, options?: any): AxiosPromise<void> {
            return localVarFp.organizationSetComplianceLevel(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
export class OrganizationApi extends BaseAPI {
    /**
     * 
     * @summary Gets the current compliance level of the organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationGetComplianceLevel(options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationGetComplianceLevel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of org owner User Ids for current org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationGetNumOrgOwners(options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationGetNumOrgOwners(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets the current compliance level of the organization
     * @param {number} [body] EmailTemplate to be used for the organization for the given template type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationSetComplianceLevel(body?: number, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationSetComplianceLevel(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get users permissions in the current user context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get users permissions in the current user context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionsObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get users permissions in the current user context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissions(options?: any): AxiosPromise<PermissionsObject> {
            return localVarFp.getPermissions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * 
     * @summary Get users permissions in the current user context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getPermissions(options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getPermissions(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PredefinedRolesApi - axios parameter creator
 * @export
 */
export const PredefinedRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get available predefined roles and their permissions, disregarding the user context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedRoles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/predefined-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredefinedRolesApi - functional programming interface
 * @export
 */
export const PredefinedRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredefinedRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get available predefined roles and their permissions, disregarding the user context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPredefinedRoles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PredefinedRole>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPredefinedRoles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PredefinedRolesApi - factory interface
 * @export
 */
export const PredefinedRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredefinedRolesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get available predefined roles and their permissions, disregarding the user context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedRoles(options?: any): AxiosPromise<Array<PredefinedRole>> {
            return localVarFp.getPredefinedRoles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PredefinedRolesApi - object-oriented interface
 * @export
 * @class PredefinedRolesApi
 * @extends {BaseAPI}
 */
export class PredefinedRolesApi extends BaseAPI {
    /**
     * 
     * @summary Get available predefined roles and their permissions, disregarding the user context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredefinedRolesApi
     */
    public getPredefinedRoles(options?: AxiosRequestConfig) {
        return PredefinedRolesApiFp(this.configuration).getPredefinedRoles(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProductsAsDistributor: async (customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getCustomerProductsAsDistributor', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/distributor/customers/{customerOrganizationId}/products`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProductsAsReseller: async (customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getCustomerProductsAsReseller', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/reseller/customers/{customerOrganizationId}/products`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerProductsAsDistributor(customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerProductsAsDistributor(customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerProductsAsReseller(customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerProductsAsReseller(customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProductsAsDistributor(customerOrganizationId: string, options?: any): AxiosPromise<ProductResultSet> {
            return localVarFp.getCustomerProductsAsDistributor(customerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProductsAsReseller(customerOrganizationId: string, options?: any): AxiosPromise<ProductResultSet> {
            return localVarFp.getCustomerProductsAsReseller(customerOrganizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * Retrieves the information of all products of an end customer
     * @summary retrieve end customer products
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getCustomerProductsAsDistributor(customerOrganizationId: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getCustomerProductsAsDistributor(customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the information of all products of an end customer
     * @summary retrieve end customer products
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getCustomerProductsAsReseller(customerOrganizationId: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getCustomerProductsAsReseller(customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PurchaseordersApi - axios parameter creator
 * @export
 */
export const PurchaseordersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a purchase order attributed to current distributor organization
         * @summary Get a distributor purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorPurchaseOrderById: async (purchaseorderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderId' is not null or undefined
            assertParamExists('getDistributorPurchaseOrderById', 'purchaseorderId', purchaseorderId)
            const localVarPath = `/v1/distributor/purchaseorders/{purchaseorderId}`
                .replace(`{${"purchaseorderId"}}`, encodeURIComponent(String(purchaseorderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all purchase orders attributed to current distributor organization
         * @summary Get distributor purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorPurchaseOrders: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/purchaseorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a purchase order attributed to current reseller organization
         * @summary Get a reseller purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerPurchaseOrderById: async (purchaseorderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderId' is not null or undefined
            assertParamExists('getResellerPurchaseOrderById', 'purchaseorderId', purchaseorderId)
            const localVarPath = `/v1/reseller/purchaseorders/{purchaseorderId}`
                .replace(`{${"purchaseorderId"}}`, encodeURIComponent(String(purchaseorderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all purchase orders attributed to current reseller organization
         * @summary Get reseller purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerPurchaseOrders: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/purchaseorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes distributor purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributorPurchaseOrdersSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/purchaseorders/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes reseller purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResellerPurchaseOrdersSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/purchaseorders/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseordersApi - functional programming interface
 * @export
 */
export const PurchaseordersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseordersApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a purchase order attributed to current distributor organization
         * @summary Get a distributor purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistributorPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPurchaseOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistributorPurchaseOrderById(purchaseorderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all purchase orders attributed to current distributor organization
         * @summary Get distributor purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistributorPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPurchaseOrderResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistributorPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a purchase order attributed to current reseller organization
         * @summary Get a reseller purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellerPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPurchaseOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellerPurchaseOrderById(purchaseorderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all purchase orders attributed to current reseller organization
         * @summary Get reseller purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellerPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPurchaseOrderResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellerPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes distributor purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDistributorPurchaseOrdersSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDistributorPurchaseOrdersSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes reseller purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listResellerPurchaseOrdersSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listResellerPurchaseOrdersSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PurchaseordersApi - factory interface
 * @export
 */
export const PurchaseordersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseordersApiFp(configuration)
    return {
        /**
         * Get a purchase order attributed to current distributor organization
         * @summary Get a distributor purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorPurchaseOrderById(purchaseorderId: string, options?: any): AxiosPromise<PartnerPurchaseOrderResponse> {
            return localVarFp.getDistributorPurchaseOrderById(purchaseorderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all purchase orders attributed to current distributor organization
         * @summary Get distributor purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributorPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<PartnerPurchaseOrderResponseSet> {
            return localVarFp.getDistributorPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a purchase order attributed to current reseller organization
         * @summary Get a reseller purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerPurchaseOrderById(purchaseorderId: string, options?: any): AxiosPromise<PartnerPurchaseOrderResponse> {
            return localVarFp.getResellerPurchaseOrderById(purchaseorderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all purchase orders attributed to current reseller organization
         * @summary Get reseller purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<PartnerPurchaseOrderResponseSet> {
            return localVarFp.getResellerPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes distributor purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributorPurchaseOrdersSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listDistributorPurchaseOrdersSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes reseller purchaseorders searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResellerPurchaseOrdersSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listResellerPurchaseOrdersSearchDescription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseordersApi - object-oriented interface
 * @export
 * @class PurchaseordersApi
 * @extends {BaseAPI}
 */
export class PurchaseordersApi extends BaseAPI {
    /**
     * Get a purchase order attributed to current distributor organization
     * @summary Get a distributor purchase order by id
     * @param {string} purchaseorderId ID of purchase order that needs to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseordersApi
     */
    public getDistributorPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig) {
        return PurchaseordersApiFp(this.configuration).getDistributorPurchaseOrderById(purchaseorderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all purchase orders attributed to current distributor organization
     * @summary Get distributor purchase orders
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseordersApi
     */
    public getDistributorPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return PurchaseordersApiFp(this.configuration).getDistributorPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a purchase order attributed to current reseller organization
     * @summary Get a reseller purchase order by id
     * @param {string} purchaseorderId ID of purchase order that needs to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseordersApi
     */
    public getResellerPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig) {
        return PurchaseordersApiFp(this.configuration).getResellerPurchaseOrderById(purchaseorderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all purchase orders attributed to current reseller organization
     * @summary Get reseller purchase orders
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseordersApi
     */
    public getResellerPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return PurchaseordersApiFp(this.configuration).getResellerPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes distributor purchaseorders searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseordersApi
     */
    public listDistributorPurchaseOrdersSearchDescription(options?: AxiosRequestConfig) {
        return PurchaseordersApiFp(this.configuration).listDistributorPurchaseOrdersSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes reseller purchaseorders searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseordersApi
     */
    public listResellerPurchaseOrdersSearchDescription(options?: AxiosRequestConfig) {
        return PurchaseordersApiFp(this.configuration).listResellerPurchaseOrdersSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RelationshipsApi - axios parameter creator
 * @export
 */
export const RelationshipsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list of relationships on distributor
         * @summary Get list of relationships on distributor
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipsOnDistributor: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of relationships on reseller
         * @summary Get list of relationships on reseller
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipsOnReseller: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant visibility of inventory to a customer organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCustomerVisilibity: async (orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orgRelationshipsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant visibility of inventory to a reseller organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantResellerVisilibity: async (orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orgRelationshipsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributorRelationshipsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/distributor/relationships/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResellerRelationshipsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/relationships/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke the visilibity of inventory of a customer organization
         * @summary Revoke inventory visibility of organization
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeCustomerVisibility: async (customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('revokeCustomerVisibility', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/reseller/relationships/{customerOrganizationId}`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke the visilibity of inventory of a reseller organization
         * @summary Revoke inventory visibility of organization
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeResellerVisibility: async (resellerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('revokeResellerVisibility', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/distributor/relationships/{resellerOrganizationId}`
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelationshipsApi - functional programming interface
 * @export
 */
export const RelationshipsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelationshipsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list of relationships on distributor
         * @summary Get list of relationships on distributor
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipsOnDistributor(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRelationshipsResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipsOnDistributor(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of relationships on reseller
         * @summary Get list of relationships on reseller
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipsOnReseller(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRelationshipsResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipsOnReseller(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grant visibility of inventory to a customer organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCustomerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRelationshipsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCustomerVisilibity(orgRelationshipsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grant visibility of inventory to a reseller organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantResellerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRelationshipsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantResellerVisilibity(orgRelationshipsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDistributorRelationshipsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDistributorRelationshipsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listResellerRelationshipsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listResellerRelationshipsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Revoke the visilibity of inventory of a customer organization
         * @summary Revoke inventory visibility of organization
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeCustomerVisibility(customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeCustomerVisibility(customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Revoke the visilibity of inventory of a reseller organization
         * @summary Revoke inventory visibility of organization
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeResellerVisibility(resellerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeResellerVisibility(resellerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RelationshipsApi - factory interface
 * @export
 */
export const RelationshipsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelationshipsApiFp(configuration)
    return {
        /**
         * Get list of relationships on distributor
         * @summary Get list of relationships on distributor
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipsOnDistributor(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<OrgRelationshipsResponseSet> {
            return localVarFp.getRelationshipsOnDistributor(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of relationships on reseller
         * @summary Get list of relationships on reseller
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipsOnReseller(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<OrgRelationshipsResponseSet> {
            return localVarFp.getRelationshipsOnReseller(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant visibility of inventory to a customer organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCustomerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: any): AxiosPromise<OrgRelationshipsResponse> {
            return localVarFp.grantCustomerVisilibity(orgRelationshipsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant visibility of inventory to a reseller organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantResellerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: any): AxiosPromise<OrgRelationshipsResponse> {
            return localVarFp.grantResellerVisilibity(orgRelationshipsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes distributor relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributorRelationshipsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listDistributorRelationshipsSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResellerRelationshipsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listResellerRelationshipsSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke the visilibity of inventory of a customer organization
         * @summary Revoke inventory visibility of organization
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeCustomerVisibility(customerOrganizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.revokeCustomerVisibility(customerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke the visilibity of inventory of a reseller organization
         * @summary Revoke inventory visibility of organization
         * @param {string} resellerOrganizationId reseller organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeResellerVisibility(resellerOrganizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.revokeResellerVisibility(resellerOrganizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelationshipsApi - object-oriented interface
 * @export
 * @class RelationshipsApi
 * @extends {BaseAPI}
 */
export class RelationshipsApi extends BaseAPI {
    /**
     * Get list of relationships on distributor
     * @summary Get list of relationships on distributor
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public getRelationshipsOnDistributor(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).getRelationshipsOnDistributor(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of relationships on reseller
     * @summary Get list of relationships on reseller
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public getRelationshipsOnReseller(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).getRelationshipsOnReseller(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant visibility of inventory to a customer organization
     * @summary Grant inventory visibility to organization
     * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public grantCustomerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).grantCustomerVisilibity(orgRelationshipsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant visibility of inventory to a reseller organization
     * @summary Grant inventory visibility to organization
     * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public grantResellerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).grantResellerVisilibity(orgRelationshipsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes distributor relationships searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public listDistributorRelationshipsSearchDescription(options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).listDistributorRelationshipsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes reseller relationships searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public listResellerRelationshipsSearchDescription(options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).listResellerRelationshipsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke the visilibity of inventory of a customer organization
     * @summary Revoke inventory visibility of organization
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public revokeCustomerVisibility(customerOrganizationId: string, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).revokeCustomerVisibility(customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke the visilibity of inventory of a reseller organization
     * @summary Revoke inventory visibility of organization
     * @param {string} resellerOrganizationId reseller organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipsApi
     */
    public revokeResellerVisibility(resellerOrganizationId: string, options?: AxiosRequestConfig) {
        return RelationshipsApiFp(this.configuration).revokeResellerVisibility(resellerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellerApi - axios parameter creator
 * @export
 */
export const ResellerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves end customer purchase order and product information aquired through distributor\'s reseller partner
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDashboardAsDistributor: async (customerOrganizationId: string, resellerOrganizationId: string, shippableOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getCustomerDashboardAsDistributor', 'customerOrganizationId', customerOrganizationId)
            // verify required parameter 'resellerOrganizationId' is not null or undefined
            assertParamExists('getCustomerDashboardAsDistributor', 'resellerOrganizationId', resellerOrganizationId)
            const localVarPath = `/v1/distributor/resellers/{resellerOrganizationId}/customers/{customerOrganizationId}`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)))
                .replace(`{${"resellerOrganizationId"}}`, encodeURIComponent(String(resellerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (shippableOnly !== undefined) {
                localVarQueryParameter['shippable_only'] = shippableOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a reseller\'s end customer purchase order and product information
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDashboardAsReseller: async (customerOrganizationId: string, shippableOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getCustomerDashboardAsReseller', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/reseller/customers/{customerOrganizationId}`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (shippableOnly !== undefined) {
                localVarQueryParameter['shippable_only'] = shippableOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProductsAsReseller: async (customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('getCustomerProductsAsReseller', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/reseller/customers/{customerOrganizationId}/products`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of relationships on reseller
         * @summary Get list of relationships on reseller
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipsOnReseller: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a purchase order attributed to current reseller organization
         * @summary Get a reseller purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerPurchaseOrderById: async (purchaseorderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseorderId' is not null or undefined
            assertParamExists('getResellerPurchaseOrderById', 'purchaseorderId', purchaseorderId)
            const localVarPath = `/v1/reseller/purchaseorders/{purchaseorderId}`
                .replace(`{${"purchaseorderId"}}`, encodeURIComponent(String(purchaseorderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all purchase orders attributed to current reseller organization
         * @summary Get reseller purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerPurchaseOrders: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/purchaseorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get purchase order summary for the current reseller organization
         * @summary Get reseller view
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerView: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant visibility of inventory to a customer organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCustomerVisilibity: async (orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/relationships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orgRelationshipsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResellerRelationshipsSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/relationships/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list that describes reseller view searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResellerViewSearchDescription: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reseller/search-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke the visilibity of inventory of a customer organization
         * @summary Revoke inventory visibility of organization
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeCustomerVisibility: async (customerOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerOrganizationId' is not null or undefined
            assertParamExists('revokeCustomerVisibility', 'customerOrganizationId', customerOrganizationId)
            const localVarPath = `/v1/reseller/relationships/{customerOrganizationId}`
                .replace(`{${"customerOrganizationId"}}`, encodeURIComponent(String(customerOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellerApi - functional programming interface
 * @export
 */
export const ResellerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves end customer purchase order and product information aquired through distributor\'s reseller partner
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDashboardAsDistributor(customerOrganizationId: string, resellerOrganizationId: string, shippableOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributorCustomerViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDashboardAsDistributor(customerOrganizationId, resellerOrganizationId, shippableOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a reseller\'s end customer purchase order and product information
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDashboardAsReseller(customerOrganizationId: string, shippableOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellerCustomerViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDashboardAsReseller(customerOrganizationId, shippableOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerProductsAsReseller(customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerProductsAsReseller(customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of relationships on reseller
         * @summary Get list of relationships on reseller
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipsOnReseller(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRelationshipsResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipsOnReseller(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a purchase order attributed to current reseller organization
         * @summary Get a reseller purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellerPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPurchaseOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellerPurchaseOrderById(purchaseorderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all purchase orders attributed to current reseller organization
         * @summary Get reseller purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellerPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerPurchaseOrderResponseSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellerPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get purchase order summary for the current reseller organization
         * @summary Get reseller view
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellerView(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellerViewResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellerView(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Grant visibility of inventory to a customer organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCustomerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgRelationshipsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCustomerVisilibity(orgRelationshipsCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listResellerRelationshipsSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listResellerRelationshipsSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list that describes reseller view searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listResellerViewSearchDescription(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchDescription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listResellerViewSearchDescription(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Revoke the visilibity of inventory of a customer organization
         * @summary Revoke inventory visibility of organization
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeCustomerVisibility(customerOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeCustomerVisibility(customerOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellerApi - factory interface
 * @export
 */
export const ResellerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellerApiFp(configuration)
    return {
        /**
         * Retrieves end customer purchase order and product information aquired through distributor\'s reseller partner
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {string} resellerOrganizationId reseller organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDashboardAsDistributor(customerOrganizationId: string, resellerOrganizationId: string, shippableOnly?: boolean, options?: any): AxiosPromise<DistributorCustomerViewResponse> {
            return localVarFp.getCustomerDashboardAsDistributor(customerOrganizationId, resellerOrganizationId, shippableOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a reseller\'s end customer purchase order and product information
         * @summary retrieve end customer dashbaord details
         * @param {string} customerOrganizationId end customer organization id
         * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDashboardAsReseller(customerOrganizationId: string, shippableOnly?: boolean, options?: any): AxiosPromise<ResellerCustomerViewResponse> {
            return localVarFp.getCustomerDashboardAsReseller(customerOrganizationId, shippableOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the information of all products of an end customer
         * @summary retrieve end customer products
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProductsAsReseller(customerOrganizationId: string, options?: any): AxiosPromise<ProductResultSet> {
            return localVarFp.getCustomerProductsAsReseller(customerOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of relationships on reseller
         * @summary Get list of relationships on reseller
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipsOnReseller(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<OrgRelationshipsResponseSet> {
            return localVarFp.getRelationshipsOnReseller(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a purchase order attributed to current reseller organization
         * @summary Get a reseller purchase order by id
         * @param {string} purchaseorderId ID of purchase order that needs to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerPurchaseOrderById(purchaseorderId: string, options?: any): AxiosPromise<PartnerPurchaseOrderResponse> {
            return localVarFp.getResellerPurchaseOrderById(purchaseorderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all purchase orders attributed to current reseller organization
         * @summary Get reseller purchase orders
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<PartnerPurchaseOrderResponseSet> {
            return localVarFp.getResellerPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get purchase order summary for the current reseller organization
         * @summary Get reseller view
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerView(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<ResellerViewResultSet> {
            return localVarFp.getResellerView(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant visibility of inventory to a customer organization
         * @summary Grant inventory visibility to organization
         * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCustomerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: any): AxiosPromise<OrgRelationshipsResponse> {
            return localVarFp.grantCustomerVisilibity(orgRelationshipsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes reseller relationships searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResellerRelationshipsSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listResellerRelationshipsSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list that describes reseller view searchable fields
         * @summary Lists searchable fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResellerViewSearchDescription(options?: any): AxiosPromise<SearchDescription> {
            return localVarFp.listResellerViewSearchDescription(options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke the visilibity of inventory of a customer organization
         * @summary Revoke inventory visibility of organization
         * @param {string} customerOrganizationId end customer organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeCustomerVisibility(customerOrganizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.revokeCustomerVisibility(customerOrganizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellerApi - object-oriented interface
 * @export
 * @class ResellerApi
 * @extends {BaseAPI}
 */
export class ResellerApi extends BaseAPI {
    /**
     * Retrieves end customer purchase order and product information aquired through distributor\'s reseller partner
     * @summary retrieve end customer dashbaord details
     * @param {string} customerOrganizationId end customer organization id
     * @param {string} resellerOrganizationId reseller organization id
     * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public getCustomerDashboardAsDistributor(customerOrganizationId: string, resellerOrganizationId: string, shippableOnly?: boolean, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).getCustomerDashboardAsDistributor(customerOrganizationId, resellerOrganizationId, shippableOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a reseller\'s end customer purchase order and product information
     * @summary retrieve end customer dashbaord details
     * @param {string} customerOrganizationId end customer organization id
     * @param {boolean} [shippableOnly] Show shippable inventory only, rather than all inventory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public getCustomerDashboardAsReseller(customerOrganizationId: string, shippableOnly?: boolean, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).getCustomerDashboardAsReseller(customerOrganizationId, shippableOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the information of all products of an end customer
     * @summary retrieve end customer products
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public getCustomerProductsAsReseller(customerOrganizationId: string, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).getCustomerProductsAsReseller(customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of relationships on reseller
     * @summary Get list of relationships on reseller
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public getRelationshipsOnReseller(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).getRelationshipsOnReseller(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a purchase order attributed to current reseller organization
     * @summary Get a reseller purchase order by id
     * @param {string} purchaseorderId ID of purchase order that needs to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public getResellerPurchaseOrderById(purchaseorderId: string, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).getResellerPurchaseOrderById(purchaseorderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all purchase orders attributed to current reseller organization
     * @summary Get reseller purchase orders
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public getResellerPurchaseOrders(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).getResellerPurchaseOrders(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get purchase order summary for the current reseller organization
     * @summary Get reseller view
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public getResellerView(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).getResellerView(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant visibility of inventory to a customer organization
     * @summary Grant inventory visibility to organization
     * @param {OrgRelationshipsCreateRequest} [orgRelationshipsCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public grantCustomerVisilibity(orgRelationshipsCreateRequest?: OrgRelationshipsCreateRequest, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).grantCustomerVisilibity(orgRelationshipsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes reseller relationships searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public listResellerRelationshipsSearchDescription(options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).listResellerRelationshipsSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list that describes reseller view searchable fields
     * @summary Lists searchable fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public listResellerViewSearchDescription(options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).listResellerViewSearchDescription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke the visilibity of inventory of a customer organization
     * @summary Revoke inventory visibility of organization
     * @param {string} customerOrganizationId end customer organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerApi
     */
    public revokeCustomerVisibility(customerOrganizationId: string, options?: AxiosRequestConfig) {
        return ResellerApiFp(this.configuration).revokeCustomerVisibility(customerOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RivendellApi - axios parameter creator
 * @export
 */
export const RivendellApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Claim grant.
         * @summary Claim grant
         * @param {string} grantId The ID of the grant
         * @param {GrantClaimRequest} grantClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimGrant: async (grantId: string, grantClaimRequest: GrantClaimRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('claimGrant', 'grantId', grantId)
            // verify required parameter 'grantClaimRequest' is not null or undefined
            assertParamExists('claimGrant', 'grantClaimRequest', grantClaimRequest)
            const localVarPath = `/rivendell/grant/{grantId}`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantClaimRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Grant by Id.
         * @summary Get Grant by Id
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrantById: async (grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('getGrantById', 'grantId', grantId)
            const localVarPath = `/rivendell/grant/{grantId}`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate address for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {MailingAddress} mailingAddress address to validate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAddressValidation: async (grantId: string, mailingAddress: MailingAddress, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('grantAddressValidation', 'grantId', grantId)
            // verify required parameter 'mailingAddress' is not null or undefined
            assertParamExists('grantAddressValidation', 'mailingAddress', mailingAddress)
            const localVarPath = `/rivendell/grant/{grantId}/validate-address`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mailingAddress, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of countries that the recipient is allowed to choose as a shipping destination.
         * @summary Retrieve the list of countries for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCountries: async (grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('grantCountries', 'grantId', grantId)
            const localVarPath = `/rivendell/grant/{grantId}/countries`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of products for a specific grant.
         * @summary Retrieve the list of products for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantProductsInfo: async (grantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('grantProductsInfo', 'grantId', grantId)
            const localVarPath = `/rivendell/grant/{grantId}/products`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update grant shipment request.
         * @summary Update grant shipment request
         * @param {string} grantId The ID of the grant
         * @param {GrantClaimRequest} grantClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGrantShipmentRequest: async (grantId: string, grantClaimRequest: GrantClaimRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('updateGrantShipmentRequest', 'grantId', grantId)
            // verify required parameter 'grantClaimRequest' is not null or undefined
            assertParamExists('updateGrantShipmentRequest', 'grantClaimRequest', grantClaimRequest)
            const localVarPath = `/rivendell/grant/{grantId}`
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantClaimRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RivendellApi - functional programming interface
 * @export
 */
export const RivendellApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RivendellApiAxiosParamCreator(configuration)
    return {
        /**
         * Claim grant.
         * @summary Claim grant
         * @param {string} grantId The ID of the grant
         * @param {GrantClaimRequest} grantClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimGrant(grantId: string, grantClaimRequest: GrantClaimRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimGrant(grantId, grantClaimRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Grant by Id.
         * @summary Get Grant by Id
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrantById(grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantClaimResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrantById(grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate address for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {MailingAddress} mailingAddress address to validate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantAddressValidation(grantId: string, mailingAddress: MailingAddress, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantAddressValidation(grantId, mailingAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the list of countries that the recipient is allowed to choose as a shipping destination.
         * @summary Retrieve the list of countries for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCountries(grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GrantCountry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCountries(grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the list of products for a specific grant.
         * @summary Retrieve the list of products for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantProductsInfo(grantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GrantProductInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantProductsInfo(grantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update grant shipment request.
         * @summary Update grant shipment request
         * @param {string} grantId The ID of the grant
         * @param {GrantClaimRequest} grantClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGrantShipmentRequest(grantId: string, grantClaimRequest: GrantClaimRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGrantShipmentRequest(grantId, grantClaimRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RivendellApi - factory interface
 * @export
 */
export const RivendellApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RivendellApiFp(configuration)
    return {
        /**
         * Claim grant.
         * @summary Claim grant
         * @param {string} grantId The ID of the grant
         * @param {GrantClaimRequest} grantClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimGrant(grantId: string, grantClaimRequest: GrantClaimRequest, options?: any): AxiosPromise<void> {
            return localVarFp.claimGrant(grantId, grantClaimRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Grant by Id.
         * @summary Get Grant by Id
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrantById(grantId: string, options?: any): AxiosPromise<GrantClaimResponse> {
            return localVarFp.getGrantById(grantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate address for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {MailingAddress} mailingAddress address to validate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAddressValidation(grantId: string, mailingAddress: MailingAddress, options?: any): AxiosPromise<void> {
            return localVarFp.grantAddressValidation(grantId, mailingAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of countries that the recipient is allowed to choose as a shipping destination.
         * @summary Retrieve the list of countries for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCountries(grantId: string, options?: any): AxiosPromise<Array<GrantCountry>> {
            return localVarFp.grantCountries(grantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of products for a specific grant.
         * @summary Retrieve the list of products for a specific grant
         * @param {string} grantId The ID of the grant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantProductsInfo(grantId: string, options?: any): AxiosPromise<Array<GrantProductInfo>> {
            return localVarFp.grantProductsInfo(grantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update grant shipment request.
         * @summary Update grant shipment request
         * @param {string} grantId The ID of the grant
         * @param {GrantClaimRequest} grantClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGrantShipmentRequest(grantId: string, grantClaimRequest: GrantClaimRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateGrantShipmentRequest(grantId, grantClaimRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RivendellApi - object-oriented interface
 * @export
 * @class RivendellApi
 * @extends {BaseAPI}
 */
export class RivendellApi extends BaseAPI {
    /**
     * Claim grant.
     * @summary Claim grant
     * @param {string} grantId The ID of the grant
     * @param {GrantClaimRequest} grantClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RivendellApi
     */
    public claimGrant(grantId: string, grantClaimRequest: GrantClaimRequest, options?: AxiosRequestConfig) {
        return RivendellApiFp(this.configuration).claimGrant(grantId, grantClaimRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Grant by Id.
     * @summary Get Grant by Id
     * @param {string} grantId The ID of the grant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RivendellApi
     */
    public getGrantById(grantId: string, options?: AxiosRequestConfig) {
        return RivendellApiFp(this.configuration).getGrantById(grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate address for a specific grant
     * @param {string} grantId The ID of the grant
     * @param {MailingAddress} mailingAddress address to validate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RivendellApi
     */
    public grantAddressValidation(grantId: string, mailingAddress: MailingAddress, options?: AxiosRequestConfig) {
        return RivendellApiFp(this.configuration).grantAddressValidation(grantId, mailingAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of countries that the recipient is allowed to choose as a shipping destination.
     * @summary Retrieve the list of countries for a specific grant
     * @param {string} grantId The ID of the grant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RivendellApi
     */
    public grantCountries(grantId: string, options?: AxiosRequestConfig) {
        return RivendellApiFp(this.configuration).grantCountries(grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of products for a specific grant.
     * @summary Retrieve the list of products for a specific grant
     * @param {string} grantId The ID of the grant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RivendellApi
     */
    public grantProductsInfo(grantId: string, options?: AxiosRequestConfig) {
        return RivendellApiFp(this.configuration).grantProductsInfo(grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update grant shipment request.
     * @summary Update grant shipment request
     * @param {string} grantId The ID of the grant
     * @param {GrantClaimRequest} grantClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RivendellApi
     */
    public updateGrantShipmentRequest(grantId: string, grantClaimRequest: GrantClaimRequest, options?: AxiosRequestConfig) {
        return RivendellApiFp(this.configuration).updateGrantShipmentRequest(grantId, grantClaimRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShipmentStatesApi - axios parameter creator
 * @export
 */
export const ShipmentStatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available shipment states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentStates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shipments/states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShipmentStatesApi - functional programming interface
 * @export
 */
export const ShipmentStatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShipmentStatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all available shipment states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentStates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShipmentStateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentStates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShipmentStatesApi - factory interface
 * @export
 */
export const ShipmentStatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShipmentStatesApiFp(configuration)
    return {
        /**
         * 
         * @summary List all available shipment states
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentStates(options?: any): AxiosPromise<Array<ShipmentStateResponse>> {
            return localVarFp.getShipmentStates(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShipmentStatesApi - object-oriented interface
 * @export
 * @class ShipmentStatesApi
 * @extends {BaseAPI}
 */
export class ShipmentStatesApi extends BaseAPI {
    /**
     * 
     * @summary List all available shipment states
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentStatesApi
     */
    public getShipmentStates(options?: AxiosRequestConfig) {
        return ShipmentStatesApiFp(this.configuration).getShipmentStates(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShipmentsApi - axios parameter creator
 * @export
 */
export const ShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Place a request for multiple shipments for an organization. This is restricted to users in the organization associated with the authentication token
         * @summary Create a bulk shipment
         * @param {boolean} [bypass] Should duplicate file upload checking be bypassed during file processing? If set to true, the user will not receive a warning should they upload a duplicate file
         * @param {File} [addressesCsv] 
         * @param {ShipmentRequest} [shipmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkShipment: async (bypass?: boolean, addressesCsv?: File, shipmentRequest?: ShipmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shipments/bulk-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (bypass !== undefined) {
                localVarQueryParameter['bypass'] = bypass;
            }


            if (addressesCsv !== undefined) { 
                localVarFormParams.append('addresses_csv', addressesCsv as any);
            }
    
            if (shipmentRequest !== undefined) { 
                localVarFormParams.append('shipment_request', new Blob([JSON.stringify(shipmentRequest)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the csv address template to be used when creating new bulk shipment requests
         * @summary Get address template for creating bulk shipment requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBulkShipmentAddressTemplate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/bulk-address-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a shipment\'s Debit to Allocation records by its ShipmentId
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentDebitAllocationsByShipmentId: async (shipmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shipmentId' is not null or undefined
            assertParamExists('getShipmentDebitAllocationsByShipmentId', 'shipmentId', shipmentId)
            const localVarPath = `/v1/shipments_exact/{shipmentId}/allocation-details`
                .replace(`{${"shipmentId"}}`, encodeURIComponent(String(shipmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShipmentsApi - functional programming interface
 * @export
 */
export const ShipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Place a request for multiple shipments for an organization. This is restricted to users in the organization associated with the authentication token
         * @summary Create a bulk shipment
         * @param {boolean} [bypass] Should duplicate file upload checking be bypassed during file processing? If set to true, the user will not receive a warning should they upload a duplicate file
         * @param {File} [addressesCsv] 
         * @param {ShipmentRequest} [shipmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBulkShipment(bypass?: boolean, addressesCsv?: File, shipmentRequest?: ShipmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBulkShipment(bypass, addressesCsv, shipmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the csv address template to be used when creating new bulk shipment requests
         * @summary Get address template for creating bulk shipment requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBulkShipmentAddressTemplate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBulkShipmentAddressTemplate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a shipment\'s Debit to Allocation records by its ShipmentId
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentDebitAllocationsByShipmentId(shipmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShipmentDebitAllocationResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentDebitAllocationsByShipmentId(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShipmentsApi - factory interface
 * @export
 */
export const ShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShipmentsApiFp(configuration)
    return {
        /**
         * Place a request for multiple shipments for an organization. This is restricted to users in the organization associated with the authentication token
         * @summary Create a bulk shipment
         * @param {boolean} [bypass] Should duplicate file upload checking be bypassed during file processing? If set to true, the user will not receive a warning should they upload a duplicate file
         * @param {File} [addressesCsv] 
         * @param {ShipmentRequest} [shipmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkShipment(bypass?: boolean, addressesCsv?: File, shipmentRequest?: ShipmentRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createBulkShipment(bypass, addressesCsv, shipmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the csv address template to be used when creating new bulk shipment requests
         * @summary Get address template for creating bulk shipment requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBulkShipmentAddressTemplate(options?: any): AxiosPromise<string> {
            return localVarFp.getBulkShipmentAddressTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a shipment\'s Debit to Allocation records by its ShipmentId
         * @param {string} shipmentId ID of shipment to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentDebitAllocationsByShipmentId(shipmentId: string, options?: any): AxiosPromise<ShipmentDebitAllocationResultSet> {
            return localVarFp.getShipmentDebitAllocationsByShipmentId(shipmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShipmentsApi - object-oriented interface
 * @export
 * @class ShipmentsApi
 * @extends {BaseAPI}
 */
export class ShipmentsApi extends BaseAPI {
    /**
     * Place a request for multiple shipments for an organization. This is restricted to users in the organization associated with the authentication token
     * @summary Create a bulk shipment
     * @param {boolean} [bypass] Should duplicate file upload checking be bypassed during file processing? If set to true, the user will not receive a warning should they upload a duplicate file
     * @param {File} [addressesCsv] 
     * @param {ShipmentRequest} [shipmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public createBulkShipment(bypass?: boolean, addressesCsv?: File, shipmentRequest?: ShipmentRequest, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).createBulkShipment(bypass, addressesCsv, shipmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the csv address template to be used when creating new bulk shipment requests
     * @summary Get address template for creating bulk shipment requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public getBulkShipmentAddressTemplate(options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).getBulkShipmentAddressTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a shipment\'s Debit to Allocation records by its ShipmentId
     * @param {string} shipmentId ID of shipment to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    public getShipmentDebitAllocationsByShipmentId(shipmentId: string, options?: AxiosRequestConfig) {
        return ShipmentsApiFp(this.configuration).getShipmentDebitAllocationsByShipmentId(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UploadsApi - axios parameter creator
 * @export
 */
export const UploadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a paginated list of uploads within an organization along with the upload\'s status
         * @summary Fetches Uploads
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploads: async (offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication DevServiceAccountKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-account", configuration)

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-authorization", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchField !== undefined) {
                localVarQueryParameter['search_field'] = searchField;
            }

            if (advancedSearch !== undefined) {
                localVarQueryParameter['advanced_search'] = advancedSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadsApi - functional programming interface
 * @export
 */
export const UploadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a paginated list of uploads within an organization along with the upload\'s status
         * @summary Fetches Uploads
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUploads(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadResultSet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUploads(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadsApi - factory interface
 * @export
 */
export const UploadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadsApiFp(configuration)
    return {
        /**
         * Fetch a paginated list of uploads within an organization along with the upload\'s status
         * @summary Fetches Uploads
         * @param {number} [offset] Number of items to offset the list by (used for pagination)
         * @param {number} [limit] Number of items to limit the list by (used for pagination)
         * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
         * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
         * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
         * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
         * @param {boolean} [advancedSearch] Advanced search mode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploads(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: any): AxiosPromise<UploadResultSet> {
            return localVarFp.getUploads(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadsApi - object-oriented interface
 * @export
 * @class UploadsApi
 * @extends {BaseAPI}
 */
export class UploadsApi extends BaseAPI {
    /**
     * Fetch a paginated list of uploads within an organization along with the upload\'s status
     * @summary Fetches Uploads
     * @param {number} [offset] Number of items to offset the list by (used for pagination)
     * @param {number} [limit] Number of items to limit the list by (used for pagination)
     * @param {string} [sortBy] Field in the requested object to sort by (numerically or alphabetically)
     * @param {'ASC' | 'DESC'} [sortDirection] Direction to sort (defaults to ASC)
     * @param {GetDistributorViewSearchParameter} [search] Text term to search for within this entity. Multiple uses implies an &#x60;OR&#x60; expression.
     * @param {GetDistributorViewSearchParameter} [searchField] Combines with &#x60;search&#x60; to limit the search term to specific field. Can be used multiple times to express a selection of fields.
     * @param {boolean} [advancedSearch] Advanced search mode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadsApi
     */
    public getUploads(offset?: number, limit?: number, sortBy?: string, sortDirection?: 'ASC' | 'DESC', search?: GetDistributorViewSearchParameter, searchField?: GetDistributorViewSearchParameter, advancedSearch?: boolean, options?: AxiosRequestConfig) {
        return UploadsApiFp(this.configuration).getUploads(offset, limit, sortBy, sortDirection, search, searchField, advancedSearch, options).then((request) => request(this.axios, this.basePath));
    }
}


